"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getAddLayers;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _color15 = _interopRequireDefault(require("color"));
var _waterColorEffect2 = _interopRequireDefault(require("../shaders/waterColorEffect"));
var _excluded = ["fragmentShader"];
function getAddLayers() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var THREE = p.THREE,
    getThreeJsInternalRandomFunctions = p.getThreeJsInternalRandomFunctions;
  function setBackground(threeJs) {
    if (!threeJs.removeBackground) {
      threeJs.renderer.domElement.parentElement.parentElement.style.background = threeJs.background;
    }
  }
  function setCanvasBackground() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      threeJs = _ref.threeJs,
      disableLeftAndTop = _ref.disableLeftAndTop;
    var canvasBackgroundContainer = threeJs.canvasBackgroundContainer;
    if (canvasBackgroundContainer) {
      var getBrush = function getBrush(color, brushSegments, brushSegmentsHeight) {
        return (0, _toConsumableArray2["default"])(Array(brushSegments)).map(function (u, i) {
          return {
            distance: brushSegmentsHeight / 2 + i * brushSegmentsHeight,
            thickness: brushSegmentsHeight,
            color: color.darken(i / (brushSegments - 1) / 16).rgb()
          };
        });
      };
      var canvasBackground = threeJs.canvasBackground || [];
      var canvasFullBackground = threeJs.canvasFullBackground || [];
      var stroke = function stroke(ctx, s, d, bp) {
        var c = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var c1 = arguments.length > 5 ? arguments[5] : undefined;
        var c2 = arguments.length > 6 ? arguments[6] : undefined;
        ctx.beginPath();
        ctx.strokeStyle = bp.color;
        ctx.lineWidth = bp.thickness;
        ctx.shadowColor = bp.color;
        ctx.shadowBlur = bp.thickness / 2;
        ctx.moveTo(s[0], s[1]);
        if (c || c1 && c2) {
          ctx.bezierCurveTo(c1 ? c1[0] : s[0], c1 ? c1[1] : s[1] - c, c2 ? c2[0] : d[0], c2 ? c2[1] : d[1] - c, d[0], d[1]);
        } else {
          ctx.lineTo(d[0], d[1]);
        }
        ctx.stroke();
      };
      var drawStroke = function drawStroke(ctx, b, s, e, c, c1, c2) {
        b.forEach(function (bp) {
          ctx.beginPath();
          var r = (Math.atan2(e[1] - s[1], e[0] - s[0]) - Math.PI / 2) % (Math.PI * 2);
          stroke.apply(void 0, [ctx, [s[0] + bp.distance * Math.cos(r), s[1] + bp.distance * Math.sin(r)], [e[0] + bp.distance * Math.cos(r), e[1] + bp.distance * Math.sin(r)], bp, c].concat((0, _toConsumableArray2["default"])(c1 && c2 ? [[c1[0] + bp.distance * Math.cos(r), c1[1] + bp.distance * Math.sin(r)]] : []), (0, _toConsumableArray2["default"])(c1 && c2 ? [[c2[0] + bp.distance * Math.cos(r), c2[1] + bp.distance * Math.sin(r)]] : [])));
        });
      };
      var copyChildren = (0, _toConsumableArray2["default"])(canvasBackgroundContainer.children);
      copyChildren.forEach(function (canvas, i) {
        var n = i === 1 ? 0 : i;
        var parentContainer = threeJs.parentContainer;
        var _ref2 = i === 0 ? {
            width: parentContainer.offsetWidth,
            height: parentContainer.offsetHeight
          } : threeJs.getWidthAndHeight(n),
          width = _ref2.width,
          height = _ref2.height;
        var _ref3 = i === 0 ? {
            left: 50,
            top: 50
          } : threeJs.getLeftAndTop(n),
          left = _ref3.left,
          top = _ref3.top;
        var _ref4 = i === 0 ? {
            visibility: "visible"
          } : threeJs.getVisibility(n),
          visibility = _ref4.visibility;
        canvas.setAttribute("width", width);
        canvas.setAttribute("height", height);
        canvas.style.width = width + "px";
        canvas.style.height = height + "px";
        if (!disableLeftAndTop) {
          canvas.style.left = left + "%";
          canvas.style.top = top + "%";
        }
        canvas.style.visibility = visibility;
      });
      var versions = {
        "1": function draw1() {
          var _getThreeJsInternalRa = getThreeJsInternalRandomFunctions(),
            shuffleArray = _getThreeJsInternalRa.shuffleArray,
            getRandomInt = _getThreeJsInternalRa.getRandomInt,
            setRandomVariables = _getThreeJsInternalRa.setRandomVariables;
          setRandomVariables({
            threeJs: threeJs
          });
          copyChildren.forEach(function (canvas, i) {
            var n = i === 1 ? 0 : i;
            var parentContainer = threeJs.parentContainer;
            var _ref5 = i === 0 ? {
                width: parentContainer.offsetWidth,
                height: parentContainer.offsetHeight
              } : threeJs.getWidthAndHeight(n),
              width = _ref5.width,
              height = _ref5.height;
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, width, height);
            if (canvas.offsetWidth) {
              var _threeJs$splitScreenD, _threeJs$splitScreenD2, _threeJs$splitScreenD3, _threeJs$splitScreenD4, _threeJs$splitScreenD5;
              var splitScreenCanvasBackground = i !== 0 && (threeJs.splitScreen || n > 0) && (_threeJs$splitScreenD = threeJs.splitScreenData) !== null && _threeJs$splitScreenD !== void 0 && _threeJs$splitScreenD.renderersData && (_threeJs$splitScreenD2 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD2 !== void 0 && _threeJs$splitScreenD2.renderersData[n] && (_threeJs$splitScreenD3 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD3 !== void 0 && (_threeJs$splitScreenD4 = _threeJs$splitScreenD3.renderersData[n].canvasBackground) !== null && _threeJs$splitScreenD4 !== void 0 && _threeJs$splitScreenD4.length ? (_threeJs$splitScreenD5 = threeJs.splitScreenData) === null || _threeJs$splitScreenD5 === void 0 ? void 0 : _threeJs$splitScreenD5.renderersData[n].canvasBackground : null;
              (i === 0 && canvasFullBackground || splitScreenCanvasBackground || canvasBackground).forEach(function (backgroundData) {
                var _backgroundData$type = backgroundData.type,
                  type = _backgroundData$type === void 0 ? "" : _backgroundData$type,
                  _backgroundData$props = backgroundData.props,
                  props = _backgroundData$props === void 0 ? [] : _backgroundData$props;
                if (!threeJs.tempCanvasBackgrounds) {
                  threeJs.tempCanvasBackgrounds = {};
                }
                if (!threeJs.tempCanvasBackgrounds[type]) {
                  threeJs.tempCanvasBackgrounds[type] = {};
                }
                var saveName = JSON.stringify(props) + width + height;
                if (!threeJs.tempCanvasBackgrounds[type][saveName]) {
                  var saveCanvas = document.createElement("canvas");
                  saveCanvas.setAttribute("width", width);
                  saveCanvas.setAttribute("height", height);
                  var sCtx = saveCanvas.getContext("2d");
                  if (type === "canvas1") {
                    var _props = (0, _slicedToArray2["default"])(props, 3),
                      _props$ = _props[0],
                      color1 = _props$ === void 0 ? "#eeac56" : _props$,
                      _props$2 = _props[1],
                      color2 = _props$2 === void 0 ? "#eeac56" : _props$2,
                      _props$3 = _props[2],
                      grays = _props$3 === void 0 ? ["rgba(0,0,0,0.02)", "rgba(0,0,0,0.03)", "rgba(0,0,0,0.05)"] : _props$3;
                    var dimFloorHundred = Math.max(6, Math.min(Math.floor(width / 100) * 100, Math.floor(height / 100) * 100));
                    if (!threeJs.tempCanvasBackgrounds[type]["pattern" + color1 + color2 + dimFloorHundred]) {
                      var patternCanvas = document.createElement("canvas");
                      var _width = dimFloorHundred / 6;
                      var _height = dimFloorHundred / 6;
                      patternCanvas.setAttribute("width", _width);
                      patternCanvas.setAttribute("height", _height);
                      var _stroke = _width / 50;
                      var boxWidth = _width / 50;
                      var boxHeight = _height / 50;
                      var wI = Math.floor(_width / (boxWidth + _stroke));
                      var hI = Math.floor(_height / (boxHeight + _stroke));
                      var wA = (0, _toConsumableArray2["default"])(Array(wI));
                      var hA = (0, _toConsumableArray2["default"])(Array(hI));
                      var mW = _stroke + (wI - 1) * _stroke + (wI - 1) * boxWidth + boxWidth;
                      var mH = _stroke + (hI - 1) * _stroke + (hI - 1) * boxHeight + boxHeight;
                      if (mW !== _width) {
                        patternCanvas.setAttribute("width", mW);
                      }
                      if (mH !== _height) {
                        patternCanvas.setAttribute("width", mH);
                      }
                      var pCtx = patternCanvas.getContext("2d");
                      wA.forEach(function (v, i) {
                        hA.forEach(function (v, hi) {
                          pCtx.beginPath();
                          pCtx.rect(_stroke + i * _stroke + i * boxWidth, _stroke + hi * _stroke + hi * boxHeight, boxWidth, boxHeight);
                          var randomColorIndex = getRandomInt(0, grays.length - 1);
                          pCtx.fillStyle = grays[randomColorIndex];
                          pCtx.fill();
                          pCtx.closePath();
                        });
                      });
                      threeJs.tempCanvasBackgrounds[type]["pattern" + color1 + color2 + dimFloorHundred] = patternCanvas;
                    }
                    var tempCanvas = document.createElement("canvas");
                    tempCanvas.setAttribute("width", width);
                    tempCanvas.setAttribute("height", height);
                    var tCtx = tempCanvas.getContext("2d");
                    var shiftX = Math.max(width, height) / 2;
                    var shiftY = Math.max(width, height) / 2;
                    var gradient = tCtx.createRadialGradient(width / 2 + shiftX, height / 2 + shiftY, 1, width / 2 + shiftX, height / 2 + shiftY, Math.max(width / 2, height / 2));
                    gradient.addColorStop(0, color1);
                    gradient.addColorStop(1, color2);
                    var scaleX = height > width ? width / height : 1;
                    var scaleY = width > height ? height / width : 1;
                    tCtx.scale(scaleX, scaleY);
                    tCtx.translate(-shiftX * scaleX, -shiftY * scaleY);
                    tCtx.fillStyle = gradient;
                    tCtx.fillRect(width / 2, height / 2, Math.max(width, height), Math.max(width, height));
                    tCtx.setTransform(1, 0, 0, 1, 0, 0);
                    tCtx.fillStyle = tCtx.createPattern(threeJs.tempCanvasBackgrounds[type]["pattern" + color1 + color2 + dimFloorHundred], "repeat");
                    tCtx.fillRect(0, 0, width, height);
                    var shadowBlur = Math.min(Math.floor(width / 100) * 100, Math.floor(height / 100) * 100) / 10;
                    var inset = shadowBlur / 2;
                    sCtx.shadowBlur = shadowBlur;
                    sCtx.shadowColor = "black";
                    sCtx.fillStyle = "blue";
                    (0, _toConsumableArray2["default"])(Array(9)).forEach(function () {
                      sCtx.fillRect(inset + shadowBlur, inset + shadowBlur, width - (inset + shadowBlur) * 2, height - (inset + shadowBlur) * 2);
                    });
                    sCtx.shadowBlur = 0;
                    sCtx.globalCompositeOperation = "source-in";
                    sCtx.drawImage(tempCanvas, 0, 0);
                    tCtx.clearRect(0, 0, width, height);
                    sCtx.globalCompositeOperation = "source-over";
                  }
                  if (type === "border") {
                    var _props2 = (0, _slicedToArray2["default"])(props, 5),
                      _props2$ = _props2[0],
                      _color = _props2$ === void 0 ? "rgba(29,29,38,0.7)" : _props2$,
                      _props2$2 = _props2[1],
                      paddingTopPercent = _props2$2 === void 0 ? 2 : _props2$2,
                      _props2$3 = _props2[2],
                      paddingBottomPercent = _props2$3 === void 0 ? 2 : _props2$3,
                      _props2$4 = _props2[3],
                      paddingLeftPercent = _props2$4 === void 0 ? 2 : _props2$4,
                      _props2$5 = _props2[4],
                      paddingRightPercent = _props2$5 === void 0 ? 2 : _props2$5;
                    var rWidth = width - height * ((paddingLeftPercent + paddingRightPercent) / 100);
                    var rHeight = height - height * ((paddingTopPercent + paddingBottomPercent) / 100);
                    var strokeN = 1000;
                    var strokeWidth = rHeight / strokeN;
                    var startY = height * paddingTopPercent / 100;
                    var startX = height * paddingLeftPercent / 100;
                    var brushSegments = 3;
                    var brushSegmentsHeight = strokeWidth / brushSegments;
                    drawStroke(sCtx, getBrush(Array.isArray(_color) ? (0, _color15["default"])(_color[0]) : (0, _color15["default"])(_color), brushSegments, brushSegmentsHeight), [startX, startY], [startX + rWidth + strokeWidth, startY]);
                    drawStroke(sCtx, getBrush(Array.isArray(_color) ? (0, _color15["default"])(_color[1]) : (0, _color15["default"])(_color), brushSegments, brushSegmentsHeight), [startX + rWidth, startY], [startX + rWidth, startY + rHeight + strokeWidth]);
                    drawStroke(sCtx, getBrush(Array.isArray(_color) ? (0, _color15["default"])(_color[2]) : (0, _color15["default"])(_color), brushSegments, brushSegmentsHeight), [startX + rWidth, startY + rHeight], [startX - strokeWidth, startY + rHeight]);
                    drawStroke(sCtx, getBrush(Array.isArray(_color) ? (0, _color15["default"])(_color[3]) : (0, _color15["default"])(_color), brushSegments, brushSegmentsHeight), [startX, startY + rHeight], [startX, startY - strokeWidth]);
                  }
                  if (type === "titleBox") {
                    var setFontSize = function setFontSize(_ref6) {
                      var width = _ref6.width,
                        height = _ref6.height,
                        text = _ref6.text,
                        _ref6$bold = _ref6.bold,
                        bold = _ref6$bold === void 0 ? "400" : _ref6$bold;
                      var fontSize = 18;
                      sCtx.letterSpacing = fontSize / letterSpacingP + "px";
                      sCtx.font = ["normal", bold, fontSize + 'px Roboto, sans-serif'].join(" ");
                      var titleWidth = sCtx.measureText(text).width;
                      var titleHeight = fontSize;
                      var scaleX = width * 0.8 / titleWidth;
                      var scaleY = height * 0.8 / titleHeight;
                      var scale = Math.min(scaleX, scaleY);
                      if (minFontSize > fontSize * scale) {
                        sCtx.font = ["normal", bold, fontSize * scale + 'px Roboto, sans-serif'].join(" ");
                        minFontSize = fontSize * scale;
                        sCtx.letterSpacing = minFontSize / letterSpacingP + "px";
                      } else {
                        sCtx.font = ["normal", bold, minFontSize + 'px Roboto, sans-serif'].join(" ");
                        sCtx.letterSpacing = minFontSize / letterSpacingP + "px";
                      }
                    };
                    var _props3 = (0, _slicedToArray2["default"])(props, 11),
                      _props3$ = _props3[0],
                      _color2 = _props3$ === void 0 ? "rgba(29,29,38,0.7)" : _props3$,
                      _props3$2 = _props3[1],
                      _paddingTopPercent = _props3$2 === void 0 ? 2 : _props3$2,
                      _props3$3 = _props3[2],
                      _paddingBottomPercent = _props3$3 === void 0 ? 2 : _props3$3,
                      _props3$4 = _props3[3],
                      _paddingLeftPercent = _props3$4 === void 0 ? 2 : _props3$4,
                      _props3$5 = _props3[4],
                      _paddingRightPercent = _props3$5 === void 0 ? 2 : _props3$5,
                      _props3$6 = _props3[5],
                      widthPercent = _props3$6 === void 0 ? 30 : _props3$6,
                      _props3$7 = _props3[6],
                      heightPercent = _props3$7 === void 0 ? 10 : _props3$7,
                      _props3$8 = _props3[7],
                      title = _props3$8 === void 0 ? "THE CONSTRUCTIONS" : _props3$8,
                      _props3$9 = _props3[8],
                      subTitle = _props3$9 === void 0 ? "abstract geometric works" : _props3$9,
                      _props3$10 = _props3[9],
                      date = _props3$10 === void 0 ? "2023" : _props3$10,
                      _props3$11 = _props3[10],
                      author = _props3$11 === void 0 ? "" : _props3$11;
                    var _rWidth = width - height * ((_paddingLeftPercent + _paddingRightPercent) / 100);
                    var _rHeight = height - height * ((_paddingTopPercent + _paddingBottomPercent) / 100);
                    var _strokeN = 1000;
                    var _strokeWidth = height / _strokeN;
                    var _brushSegments = 3;
                    var _brushSegmentsHeight = _strokeWidth / _brushSegments;
                    var endY = height - height * _paddingBottomPercent / 100;
                    var endX = width - height * _paddingRightPercent / 100;
                    var wP = typeof widthPercent === "number" ? widthPercent : width > height ? widthPercent[0] : widthPercent[1];
                    var w = _rWidth / 100 * wP;
                    var h = _rHeight / 100 * heightPercent;
                    drawStroke(sCtx, getBrush((0, _color15["default"])(_color2), _brushSegments, _brushSegmentsHeight), [endX - w, endY - h], [endX, endY - h]);
                    drawStroke(sCtx, getBrush((0, _color15["default"])(_color2), _brushSegments, _brushSegmentsHeight), [endX - w, endY - h], [endX - w, endY]);
                    drawStroke(sCtx, getBrush((0, _color15["default"])(_color2), _brushSegments, _brushSegmentsHeight), [endX - w / 3, endY - h], [endX - w / 3, endY]);
                    drawStroke(sCtx, getBrush((0, _color15["default"])(_color2), _brushSegments, _brushSegmentsHeight), [endX - w, endY - h / 2], [endX, endY - h / 2]);
                    sCtx.fillStyle = _color2;
                    sCtx.textBaseline = "middle";
                    sCtx.textAlign = "center";
                    var minFontSize = 200;
                    var letterSpacingP = 8;
                    if (Array.isArray(title)) {
                      setFontSize({
                        width: w - w / 3,
                        height: h / 4,
                        text: title[0],
                        bold: "bold"
                      });
                      setFontSize({
                        width: w - w / 3,
                        height: h / 4,
                        text: title[1]
                      });
                    } else {
                      setFontSize({
                        width: w - w / 3,
                        height: h / 2,
                        text: title,
                        bold: "bold"
                      });
                    }
                    if (Array.isArray(subTitle)) {
                      setFontSize({
                        width: w - w / 3,
                        height: h / 4,
                        text: subTitle[0]
                      });
                      setFontSize({
                        width: w - w / 3,
                        height: h / 4,
                        text: subTitle[1]
                      });
                    } else {
                      setFontSize({
                        width: w - w / 3,
                        height: h / 2,
                        text: subTitle
                      });
                    }
                    setFontSize({
                      width: w / 3,
                      height: h / 2,
                      text: date
                    });
                    if (author) {
                      setFontSize({
                        width: w / 3,
                        height: h / 2,
                        text: author
                      });
                    }
                    var _shiftY = minFontSize * 0.05;
                    sCtx.font = ["normal", "bold", minFontSize + 'px Roboto, sans-serif'].join(" ");
                    if (Array.isArray(title)) {
                      var titleWidth = sCtx.measureText(title[0]).width;
                      sCtx.fillText(title[0], endX - w + (w - w / 3) / 2, endY - h + h / 2 / 2 + _shiftY - minFontSize / 2);
                      sCtx.font = "normal 400 " + minFontSize + 'px Roboto, sans-serif';
                      var title2Width = sCtx.measureText(title[1]).width;
                      var shiftYPlus = minFontSize / 3 * 2;
                      if (title2Width > titleWidth) {
                        var newFontSize = minFontSize * (titleWidth / title2Width) * 0.9;
                        sCtx.font = "normal 400 " + newFontSize + 'px Roboto, sans-serif';
                        shiftYPlus = newFontSize / 3 * 2;
                      }
                      sCtx.fillText(title[1], endX - w + (w - w / 3) / 2, endY - h + h / 2 / 2 + _shiftY + shiftYPlus);
                    } else {
                      sCtx.fillText(title, endX - w + (w - w / 3) / 2, endY - h + h / 2 / 2 + _shiftY);
                    }
                    sCtx.font = "normal 400 " + minFontSize + 'px Roboto, sans-serif';
                    if (Array.isArray(subTitle)) {
                      var subTitleWidth = sCtx.measureText(subTitle[0]).width;
                      sCtx.fillText(subTitle[0], endX - w + (w - w / 3) / 2, endY - h / 2 + h / 2 / 2 + _shiftY - minFontSize / 2);
                      sCtx.font = "normal 400 " + minFontSize + 'px Roboto, sans-serif';
                      var subTitle2Width = sCtx.measureText(subTitle[1]).width;
                      var _shiftYPlus = minFontSize / 3 * 2;
                      if (subTitle2Width > subTitleWidth) {
                        var _newFontSize = minFontSize * (subTitleWidth / subTitle2Width) * 0.9;
                        sCtx.font = "normal 400 " + _newFontSize + 'px Roboto, sans-serif';
                        _shiftYPlus = _newFontSize / 3 * 2;
                      }
                      sCtx.fillText(subTitle[1], endX - w + (w - w / 3) / 2, endY - h / 2 + h / 2 / 2 + _shiftY + _shiftYPlus);
                    } else {
                      sCtx.fillText(subTitle, endX - w + (w - w / 3) / 2, endY - h / 2 + h / 2 / 2 + _shiftY);
                    }
                    sCtx.fillText(date, endX - w / 3 + w / 3 / 2, endY - h + h / 2 / 2 + _shiftY);
                    if (author) {
                      sCtx.fillText(author, endX - w / 3 + w / 3 / 2, endY - h / 2 + h / 2 / 2 + _shiftY);
                    }
                  }
                  if (type === "carco") {
                    var drawCarco = function drawCarco(ctx) {
                      var shiftX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -100;
                      var shiftY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -100;
                      var scale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.238;
                      var lastx = 0;
                      var lasty = 0;
                      var c = {
                        moveTo: function moveTo(x, y) {
                          lastx = x;
                          lasty = y;
                          ctx.moveTo(x * scale, y * scale);
                        },
                        bezierCurveTo: function bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
                          drawStroke(ctx, brush, [lastx * scale, lasty * scale], [x * scale, y * scale], 0, [cp1x * scale, cp1y * scale], [cp2x * scale, cp2y * scale]);
                          lastx = x;
                          lasty = y;
                        }
                      };
                      c.moveTo(241 + shiftX, 153 + shiftY);
                      c.bezierCurveTo(278 + shiftX, 80 + shiftY, 204 + shiftX, 112 + shiftY, 178 + shiftX, 134 + shiftY);
                      c.bezierCurveTo(150 + shiftX, 149 + shiftY, 105 + shiftX, 220 + shiftY, 116 + shiftX, 262 + shiftY);
                      c.bezierCurveTo(123 + shiftX, 287 + shiftY, 169 + shiftX, 300 + shiftY, 196 + shiftX, 269 + shiftY);
                      //c.bezierCurveTo(219 + shiftX, 225 + shiftY, 240 + shiftX, 208 + shiftY, 264 + shiftX, 208 + shiftY);
                      c.moveTo(264 + shiftX, 208 + shiftY);
                      c.bezierCurveTo(215 + shiftX, 202 + shiftY, 199 + shiftX, 225 + shiftY, 183 + shiftX, 264 + shiftY);
                      c.bezierCurveTo(174 + shiftX, 289 + shiftY, 226 + shiftX, 300 + shiftY, 253 + shiftX, 266 + shiftY);
                      c.bezierCurveTo(270 + shiftX, 223 + shiftY, 292 + shiftX, 208 + shiftY, 275 + shiftX, 211 + shiftY);
                      c.bezierCurveTo(266 + shiftX, 200 + shiftY, 230 + shiftX, 273 + shiftY, 244 + shiftX, 283 + shiftY);
                      //c.bezierCurveTo(260 + shiftX, 288 + shiftY, 261 + shiftX, 278 + shiftY, 271 + shiftX, 269 + shiftY);
                      c.moveTo(281 + shiftX, 289 + shiftY);
                      c.bezierCurveTo(281 + shiftX, 289 + shiftY, 311 + shiftX, 220 + shiftY, 311 + shiftX, 220 + shiftY);
                      //c.bezierCurveTo(317 + shiftX, 204 + shiftY, 286 + shiftX, 228 + shiftY, 297 + shiftX, 229 + shiftY);
                      c.moveTo(307 + shiftX, 239 + shiftY);
                      c.bezierCurveTo(293 + shiftX, 244 + shiftY, 330 + shiftX, 202 + shiftY, 360 + shiftX, 224 + shiftY);
                      //c.bezierCurveTo(336 + shiftX, 207 + shiftY, 307 + shiftX, 207 + shiftY, 289 + shiftX, 241 + shiftY);
                      //c.bezierCurveTo(283 + shiftX, 253 + shiftY, 277 + shiftX, 263 + shiftY, 268 + shiftX, 283 + shiftY);
                      //c.bezierCurveTo(304 + shiftX, 227 + shiftY, 321 + shiftX, 267 + shiftY, 343 + shiftX, 249 + shiftY);
                      //c.moveTo(343 + shiftX, 249 + shiftY);
                      //c.bezierCurveTo(351 + shiftX, 232 + shiftY, 380 + shiftX, 201 + shiftY, 421 + shiftX, 213 + shiftY);
                      c.moveTo(401 + shiftX, 203 + shiftY);
                      c.bezierCurveTo(377 + shiftX, 200 + shiftY, 345 + shiftX, 221 + shiftY, 341 + shiftX, 272 + shiftY);
                      c.bezierCurveTo(334 + shiftX, 301 + shiftY, 403 + shiftX, 291 + shiftY, 418 + shiftX, 255 + shiftY);
                      c.bezierCurveTo(433 + shiftX, 233 + shiftY, 451 + shiftX, 212 + shiftY, 471 + shiftX, 213 + shiftY);
                      c.bezierCurveTo(445 + shiftX, 190 + shiftY, 412 + shiftX, 247 + shiftY, 412 + shiftX, 270 + shiftY);
                      c.bezierCurveTo(423 + shiftX, 308 + shiftY, 467 + shiftX, 286 + shiftY, 477 + shiftX, 260 + shiftY);
                      c.bezierCurveTo(492 + shiftX, 239 + shiftY, 496 + shiftX, 217 + shiftY, 480 + shiftX, 211 + shiftY);
                      c.bezierCurveTo(470 + shiftX, 211 + shiftY, 459 + shiftX, 233 + shiftY, 472 + shiftX, 234 + shiftY);
                      c.bezierCurveTo(483 + shiftX, 245 + shiftY, 510 + shiftX, 233 + shiftY, 510 + shiftX, 223 + shiftY);
                    };
                    var _props4 = (0, _slicedToArray2["default"])(props, 8),
                      _props4$ = _props4[0],
                      _color3 = _props4$ === void 0 ? "rgba(29,29,38,0.7)" : _props4$,
                      _props4$2 = _props4[1],
                      _paddingTopPercent2 = _props4$2 === void 0 ? 2 : _props4$2,
                      _props4$3 = _props4[2],
                      _paddingBottomPercent2 = _props4$3 === void 0 ? 2 : _props4$3,
                      _props4$4 = _props4[3],
                      _paddingLeftPercent2 = _props4$4 === void 0 ? 2 : _props4$4,
                      _props4$5 = _props4[4],
                      _paddingRightPercent2 = _props4$5 === void 0 ? 2 : _props4$5,
                      _props4$6 = _props4[5],
                      _widthPercent = _props4$6 === void 0 ? 10 : _props4$6,
                      _props4$7 = _props4[6],
                      _heightPercent = _props4$7 === void 0 ? 5 : _props4$7,
                      _props4$8 = _props4[7],
                      paddingPercent = _props4$8 === void 0 ? 10 : _props4$8;
                    var _rWidth2 = width - height * ((_paddingLeftPercent2 + _paddingRightPercent2) / 100);
                    var _rHeight2 = height - height * ((_paddingTopPercent2 + _paddingBottomPercent2) / 100);
                    var _strokeN2 = Math.floor(getRandomInt(250, 300));
                    var _strokeWidth2 = height / _strokeN2;
                    var _brushSegments2 = 6;
                    var _brushSegmentsHeight2 = _strokeWidth2 / _brushSegments2;
                    var _endY = height - height * _paddingBottomPercent2 / 100;
                    var _endX = width - height * _paddingRightPercent2 / 100;
                    var _wP = typeof _widthPercent === "number" ? _widthPercent : width > height ? _widthPercent[0] : _widthPercent[1];
                    var _w = _rWidth2 / 100 * _wP;
                    var _h = _rHeight2 / 100 * _heightPercent;

                    //100x46

                    var _scaleX = _w / 100 * (100 - paddingPercent * 2) / 100;
                    var _scaleY = _h / 100 * (100 - paddingPercent * 2) / 46;
                    var scale = Math.min(_scaleX, _scaleY);
                    var cW = 100 * scale;
                    var cH = 48 * scale;
                    var cD = (0, _color15["default"])(_color3);
                    var brush = getBrush(cD, _brushSegments2, _brushSegmentsHeight2);
                    sCtx.translate(_endX - _w / 2, _endY - _h / 2);
                    var randomRotate = getRandomInt(3, 8);
                    sCtx.rotate(-randomRotate * Math.PI / 180);
                    sCtx.scale(1, getRandomInt(60, 80) / 100);
                    drawCarco(sCtx, -cW / 2 / (scale * 0.238) - 100, -cH / 2 / (scale * 0.238) - 100, scale * 0.238);
                    sCtx.translate(-_endX - _w / 2, -_endY - _h / 2);
                    sCtx.scale(1, 1);
                    sCtx.setTransform(1, 0, 0, 1, 0, 0);
                  }
                  if (type === "sketchBgHorizontal") {
                    var _props5 = (0, _slicedToArray2["default"])(props, 6),
                      _props5$ = _props5[0],
                      _color4 = _props5$ === void 0 ? "rgba(115,121,128,0.3)" : _props5$,
                      _props5$2 = _props5[1],
                      _paddingTopPercent3 = _props5$2 === void 0 ? 10 : _props5$2,
                      _props5$3 = _props5[2],
                      _paddingBottomPercent3 = _props5$3 === void 0 ? 10 : _props5$3,
                      _props5$4 = _props5[3],
                      _paddingLeftPercent3 = _props5$4 === void 0 ? 10 : _props5$4,
                      _props5$5 = _props5[4],
                      _paddingRightPercent3 = _props5$5 === void 0 ? 10 : _props5$5,
                      _props5$6 = _props5[5],
                      _strokeN3 = _props5$6 === void 0 ? 20 : _props5$6;
                    var _rWidth3 = width - height * ((_paddingLeftPercent3 + _paddingRightPercent3) / 100);
                    var _rHeight3 = height - height * ((_paddingTopPercent3 + _paddingBottomPercent3) / 100);
                    var _strokeWidth3 = _rHeight3 / _strokeN3;
                    var _startY = height * _paddingTopPercent3 / 100 + _strokeWidth3;
                    var _startX = height * _paddingLeftPercent3 / 100;
                    var _brushSegments3 = 10;
                    var _brushSegmentsHeight3 = _strokeWidth3 / _brushSegments3;
                    var _cD = (0, _color15["default"])(_color4);
                    var _brush = getBrush(_cD, _brushSegments3, _brushSegmentsHeight3);
                    var endBrush = getBrush(_cD, Math.floor(_brushSegments3 / 4 * 3), _brushSegmentsHeight3);
                    var lastPoint = null;
                    var lastStart = null;
                    var shouldStartMiddleSection = null;
                    var randomShiftArray = [0, _strokeWidth3 / 10, _strokeWidth3 / 15, _strokeWidth3 / 5];
                    var randomCurveArray = [0, 4, 8, 10];
                    var overhangUp = shuffleArray([5, 7])[0];
                    var overhangDown = shuffleArray([5, 7])[0];
                    var stepY = _strokeWidth3 * shuffleArray([0.5, 1])[0];
                    var overhangUpHeight = (overhangUp / 2 - 1) * (_strokeWidth3 + stepY) + _strokeWidth3;
                    var overhangDownHeight = (overhangDown / 2 - 1) * (_strokeWidth3 + stepY) + _strokeWidth3;
                    var iL = Math.max(1, Math.floor((_rHeight3 - overhangUpHeight - overhangDownHeight) / _strokeWidth3));
                    _startY = _startY + overhangUpHeight;
                    var iBA = (0, _toConsumableArray2["default"])(Array(overhangUp));
                    iBA.forEach(function (u, i) {
                      var randomShift = shuffleArray(randomShiftArray)[0] + (i > 0 ? stepY : 0);
                      var randomCurve = shuffleArray(randomCurveArray)[0];
                      var startPoint = lastPoint ? [_startX, lastPoint[1] - randomShift] : [_startX, _startY - _strokeWidth3 * i - randomShift];
                      var endPoint = [_startX + _rWidth3, startPoint[1] - _strokeWidth3];
                      if (i > 0) {
                        startPoint = !(i % 2) ? startPoint : [startPoint[0], lastPoint[1] - randomShift];
                        endPoint = !(i % 2) ? endPoint : [endPoint[0], lastPoint[1]];
                      }
                      var curveHeight = randomCurve ? _strokeWidth3 / randomCurve : 0;
                      if (i === overhangUp - 1) {
                        endPoint = !(i % 2) ? [_startX + _rWidth3 / 2, endPoint[1] - _strokeWidth3 / 2] : endPoint;
                        startPoint = !(i % 2) ? startPoint : [_startX + _rWidth3 / 2, startPoint[1] - _strokeWidth3 / 2];
                        curveHeight = curveHeight * -4;
                      }
                      lastStart = startPoint;
                      lastPoint = endPoint;
                      if (!shouldStartMiddleSection) {
                        shouldStartMiddleSection = startPoint;
                      }
                      drawStroke(sCtx, i === overhangUp - 1 ? endBrush : _brush, startPoint, endPoint, curveHeight);
                    });
                    lastPoint = null;
                    var iA = (0, _toConsumableArray2["default"])(Array(iL));
                    iA.forEach(function (u, i) {
                      var randomShift = shuffleArray(randomShiftArray)[0];
                      var randomCurve = shuffleArray(randomCurveArray)[0];
                      var startPoint = shouldStartMiddleSection ? shouldStartMiddleSection : lastPoint ? [_startX, lastPoint[1] + _strokeWidth3 + randomShift] : [_startX, _startY + _strokeWidth3 * i + randomShift];
                      var endPoint = [_startX + _rWidth3, _startY + _strokeWidth3 * i + randomShift];
                      var curveHeight = randomCurve ? _strokeWidth3 / randomCurve : 0;
                      drawStroke(sCtx, _brush, startPoint, endPoint, curveHeight);
                      lastPoint = endPoint;
                      shouldStartMiddleSection = null;
                    });
                    _startY = lastPoint[1] + _strokeWidth3;
                    lastPoint = null;
                    lastStart = null;
                    var iAA = (0, _toConsumableArray2["default"])(Array(overhangDown));
                    iAA.forEach(function (u, i) {
                      var randomShift = shuffleArray(randomShiftArray)[0] + (i > 0 ? stepY : 0);
                      var randomCurve = shuffleArray(randomCurveArray)[0];
                      var startPoint = lastStart ? [_startX, lastStart[1] + _strokeWidth3 + randomShift] : [_startX, _startY + _strokeWidth3 * i + randomShift];
                      var endPoint = [_startX + _rWidth3, startPoint[1] - _strokeWidth3];
                      if (i > 0) {
                        startPoint = !(i % 2) ? startPoint : [startPoint[0], lastStart[1]];
                        endPoint = !(i % 2) ? endPoint : [endPoint[0], startPoint[1] + randomShift];
                      }
                      var curveHeight = randomCurve ? _strokeWidth3 / randomCurve : 0;
                      if (i === overhangDown - 1) {
                        startPoint = !(i % 2) ? [_startX + _rWidth3 / 2, startPoint[1]] : startPoint;
                        endPoint = !(i % 2) ? endPoint : [_startX + _rWidth3 / 2, endPoint[1]];
                        curveHeight = curveHeight * 4;
                      }
                      drawStroke(sCtx, i === overhangDown - 1 ? endBrush : _brush, startPoint, endPoint, curveHeight);
                      lastStart = startPoint;
                      lastPoint = endPoint;
                    });
                  }
                  if (type === "sketchBgVertical") {
                    var _props6 = (0, _slicedToArray2["default"])(props, 6),
                      _props6$ = _props6[0],
                      _color5 = _props6$ === void 0 ? "rgba(115,121,128,0.3)" : _props6$,
                      _props6$2 = _props6[1],
                      _paddingTopPercent4 = _props6$2 === void 0 ? 10 : _props6$2,
                      _props6$3 = _props6[2],
                      _paddingBottomPercent4 = _props6$3 === void 0 ? 10 : _props6$3,
                      _props6$4 = _props6[3],
                      _paddingLeftPercent4 = _props6$4 === void 0 ? 10 : _props6$4,
                      _props6$5 = _props6[4],
                      _paddingRightPercent4 = _props6$5 === void 0 ? 10 : _props6$5,
                      _props6$6 = _props6[5],
                      _strokeN4 = _props6$6 === void 0 ? 20 : _props6$6;
                    var _rWidth4 = width - height * ((_paddingLeftPercent4 + _paddingRightPercent4) / 100);
                    var _rHeight4 = height - height * ((_paddingTopPercent4 + _paddingBottomPercent4) / 100);
                    var _strokeWidth4 = _rHeight4 / _strokeN4;
                    var _startY2 = height * _paddingTopPercent4 / 100;
                    var _startX2 = height * _paddingLeftPercent4 / 100 + _strokeWidth4;
                    var _brushSegments4 = 10;
                    var _brushSegmentsHeight4 = _strokeWidth4 / _brushSegments4;
                    var _cD2 = (0, _color15["default"])(_color5);
                    var _brush2 = getBrush(_cD2, _brushSegments4, _brushSegmentsHeight4);
                    var _endBrush = getBrush(_cD2, Math.floor(_brushSegments4 / 4 * 3), _brushSegmentsHeight4);
                    var _lastPoint = null;
                    var _lastStart = null;
                    var _shouldStartMiddleSection = null;
                    var _randomShiftArray = [0, _strokeWidth4 / 10, _strokeWidth4 / 15, _strokeWidth4 / 5];
                    var _randomCurveArray = [0, 4, 8, 10];
                    var overhangLeft = shuffleArray([5, 7])[0];
                    var overhangRight = shuffleArray([5, 7])[0];
                    var _stepY = _strokeWidth4 * shuffleArray([0.5, 1])[0];
                    var overhangLeftWidth = (overhangLeft / 2 - 1) * (_strokeWidth4 + _stepY) + _strokeWidth4;
                    var overhangRightWidth = (overhangRight / 2 - 1) * (_strokeWidth4 + _stepY) + _strokeWidth4;
                    var _iL = Math.max(1, Math.floor((_rWidth4 - overhangLeftWidth - overhangRightWidth) / _strokeWidth4));
                    _startX2 = _startX2 + overhangLeftWidth;
                    var _iBA = (0, _toConsumableArray2["default"])(Array(overhangLeft));
                    _iBA.forEach(function (u, i) {
                      var randomShift = shuffleArray(_randomShiftArray)[0] + (i > 0 ? _stepY : 0);
                      var randomCurve = shuffleArray(_randomCurveArray)[0];
                      var startPoint = _lastPoint ? [_lastPoint[0] - randomShift, _startY2] : [_startX2 - _strokeWidth4 * i - randomShift, _startY2];
                      var endPoint = [startPoint[0] - _strokeWidth4, _startY2 + _rHeight4];
                      if (i > 0) {
                        startPoint = !(i % 2) ? startPoint : [_lastPoint[0] - randomShift, startPoint[1]];
                        endPoint = !(i % 2) ? endPoint : [_lastPoint[0], endPoint[1]];
                      }
                      var curveHeight = randomCurve ? _strokeWidth4 / randomCurve : 0;
                      if (i === overhangLeft - 1) {
                        endPoint = !(i % 2) ? [endPoint[0] - _strokeWidth4 / 2, _startY2 + _rHeight4 / 2] : endPoint;
                        startPoint = !(i % 2) ? startPoint : [startPoint[0] - _strokeWidth4 / 2, _startY2 + _rHeight4 / 2];
                        curveHeight = curveHeight * -4;
                      }
                      _lastStart = startPoint;
                      _lastPoint = endPoint;
                      if (!_shouldStartMiddleSection) {
                        _shouldStartMiddleSection = startPoint;
                      }
                      drawStroke(sCtx, i === overhangLeft - 1 ? _endBrush : _brush2, startPoint, endPoint, curveHeight);
                    });
                    _lastPoint = null;
                    var _iA = (0, _toConsumableArray2["default"])(Array(_iL));
                    _iA.forEach(function (u, i) {
                      var randomShift = shuffleArray(_randomShiftArray)[0];
                      var randomCurve = shuffleArray(_randomCurveArray)[0];
                      var startPoint = _shouldStartMiddleSection ? _shouldStartMiddleSection : _lastPoint ? [_lastPoint[0] + _strokeWidth4 + randomShift, _startY2] : [_startX2 + _strokeWidth4 * i + randomShift, _startY2];
                      var endPoint = [_startX2 + _strokeWidth4 * i + randomShift, _startY2 + _rHeight4];
                      var curveHeight = randomCurve ? _strokeWidth4 / randomCurve : 0;
                      drawStroke(sCtx, _brush2, startPoint, endPoint, curveHeight);
                      _lastPoint = endPoint;
                      _shouldStartMiddleSection = null;
                    });
                    _startX2 = _lastPoint[0] + _strokeWidth4;
                    _lastPoint = null;
                    _lastStart = null;
                    var _iAA = (0, _toConsumableArray2["default"])(Array(overhangRight));
                    _iAA.forEach(function (u, i) {
                      var randomShift = shuffleArray(_randomShiftArray)[0] + (i > 0 ? _stepY : 0);
                      var randomCurve = shuffleArray(_randomCurveArray)[0];
                      var startPoint = _lastStart ? [_lastStart[0] + _strokeWidth4 + randomShift, _startY2] : [_startX2 + _strokeWidth4 * i + randomShift, _startY2];
                      var endPoint = [startPoint[0] - _strokeWidth4, _startY2 + _rHeight4];
                      if (i > 0) {
                        startPoint = !(i % 2) ? startPoint : [_lastStart[0], startPoint[1]];
                        endPoint = !(i % 2) ? endPoint : [startPoint[0] + randomShift, endPoint[1]];
                      }
                      var curveHeight = randomCurve ? _strokeWidth4 / randomCurve : 0;
                      if (i === overhangRight - 1) {
                        startPoint = !(i % 2) ? [startPoint[0], _startY2 + _rHeight4 / 2] : startPoint;
                        endPoint = !(i % 2) ? endPoint : [endPoint[0], _startY2 + _rHeight4 / 2];
                        curveHeight = curveHeight * 4;
                      }
                      drawStroke(sCtx, i === overhangRight - 1 ? _endBrush : _brush2, startPoint, endPoint, curveHeight);
                      _lastStart = startPoint;
                      _lastPoint = endPoint;
                    });
                  }
                  threeJs.tempCanvasBackgrounds[type][saveName] = saveCanvas;
                }
                ctx.drawImage(threeJs.tempCanvasBackgrounds[type][saveName], 0, 0);
              });
            }
          });
        },
        "2": function draw2() {
          copyChildren.forEach(function (canvas, i) {
            var n = i === 1 ? 0 : i;
            var parentContainer = threeJs.parentContainer;
            var _ref7 = i === 0 ? {
                width: parentContainer.offsetWidth,
                height: parentContainer.offsetHeight
              } : threeJs.getWidthAndHeight(n),
              width = _ref7.width,
              height = _ref7.height;
            var ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, width, height);
            if (canvas.offsetWidth) {
              var _threeJs$splitScreenD6, _threeJs$splitScreenD7, _threeJs$splitScreenD8, _threeJs$splitScreenD9, _threeJs$splitScreenD10;
              var splitScreenCanvasBackground = i !== 0 && (threeJs.splitScreen || n > 0) && (_threeJs$splitScreenD6 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD6 !== void 0 && _threeJs$splitScreenD6.renderersData && (_threeJs$splitScreenD7 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD7 !== void 0 && _threeJs$splitScreenD7.renderersData[n] && (_threeJs$splitScreenD8 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD8 !== void 0 && (_threeJs$splitScreenD9 = _threeJs$splitScreenD8.renderersData[n].canvasBackground) !== null && _threeJs$splitScreenD9 !== void 0 && _threeJs$splitScreenD9.length ? (_threeJs$splitScreenD10 = threeJs.splitScreenData) === null || _threeJs$splitScreenD10 === void 0 ? void 0 : _threeJs$splitScreenD10.renderersData[n].canvasBackground : null;
              (i === 0 && canvasFullBackground || splitScreenCanvasBackground || canvasBackground).forEach(function (backgroundData) {
                var _backgroundData$type2 = backgroundData.type,
                  type = _backgroundData$type2 === void 0 ? "" : _backgroundData$type2,
                  visibilityStrategy = backgroundData.visibilityStrategy,
                  _backgroundData$props2 = backgroundData.props,
                  props = _backgroundData$props2 === void 0 ? [] : _backgroundData$props2;
                var go = true;
                if (visibilityStrategy !== null && visibilityStrategy !== void 0 && visibilityStrategy.length) {
                  go = false;
                  visibilityStrategy.forEach(function (ratio) {
                    if (ratio === "portrait" && width < height) {
                      go = true;
                    }
                    if (ratio === "landscape" && width > height) {
                      go = true;
                    }
                    if (ratio === "square" && width === height) {
                      go = true;
                    }
                  });
                }
                if (!go) {
                  return;
                }
                if (!threeJs.tempCanvasBackgrounds) {
                  threeJs.tempCanvasBackgrounds = {};
                }
                if (!threeJs.tempCanvasBackgrounds[type]) {
                  threeJs.tempCanvasBackgrounds[type] = {};
                }
                var saveName = JSON.stringify(props) + width + height;
                if (!threeJs.tempCanvasBackgrounds[type][saveName]) {
                  var saveCanvas = document.createElement("canvas");
                  saveCanvas.setAttribute("width", width);
                  saveCanvas.setAttribute("height", height);
                  var sCtx = saveCanvas.getContext("2d");
                  if (type === "canvas1") {
                    var _getThreeJsInternalRa2 = getThreeJsInternalRandomFunctions(),
                      getRandomInt = _getThreeJsInternalRa2.getRandomInt,
                      setRandomVariables = _getThreeJsInternalRa2.setRandomVariables;
                    setRandomVariables({
                      threeJs: threeJs
                    });
                    var _props7 = (0, _slicedToArray2["default"])(props, 3),
                      _props7$ = _props7[0],
                      color1 = _props7$ === void 0 ? "#eeac56" : _props7$,
                      _props7$2 = _props7[1],
                      color2 = _props7$2 === void 0 ? "#eeac56" : _props7$2,
                      _props7$3 = _props7[2],
                      grays = _props7$3 === void 0 ? ["rgba(0,0,0,0.02)", "rgba(0,0,0,0.03)", "rgba(0,0,0,0.05)"] : _props7$3;
                    var dimFloorHundred = Math.max(6, Math.min(Math.floor(width / 100) * 100, Math.floor(height / 100) * 100));
                    if (!threeJs.tempCanvasBackgrounds[type]["pattern" + color1 + color2 + dimFloorHundred]) {
                      var patternCanvas = document.createElement("canvas");
                      var _width2 = dimFloorHundred / 6;
                      var _height2 = dimFloorHundred / 6;
                      patternCanvas.setAttribute("width", _width2);
                      patternCanvas.setAttribute("height", _height2);
                      var _stroke2 = _width2 / 50;
                      var boxWidth = _width2 / 50;
                      var boxHeight = _height2 / 50;
                      var wI = Math.floor(_width2 / (boxWidth + _stroke2));
                      var hI = Math.floor(_height2 / (boxHeight + _stroke2));
                      var wA = (0, _toConsumableArray2["default"])(Array(wI));
                      var hA = (0, _toConsumableArray2["default"])(Array(hI));
                      var mW = _stroke2 + (wI - 1) * _stroke2 + (wI - 1) * boxWidth + boxWidth;
                      var mH = _stroke2 + (hI - 1) * _stroke2 + (hI - 1) * boxHeight + boxHeight;
                      if (mW !== _width2) {
                        patternCanvas.setAttribute("width", mW);
                      }
                      if (mH !== _height2) {
                        patternCanvas.setAttribute("width", mH);
                      }
                      var pCtx = patternCanvas.getContext("2d");
                      wA.forEach(function (v, i) {
                        hA.forEach(function (v, hi) {
                          pCtx.beginPath();
                          pCtx.rect(_stroke2 + i * _stroke2 + i * boxWidth, _stroke2 + hi * _stroke2 + hi * boxHeight, boxWidth, boxHeight);
                          var randomColorIndex = getRandomInt(0, grays.length - 1);
                          pCtx.fillStyle = grays[randomColorIndex];
                          pCtx.fill();
                          pCtx.closePath();
                        });
                      });
                      threeJs.tempCanvasBackgrounds[type]["pattern" + color1 + color2 + dimFloorHundred] = patternCanvas;
                    }
                    var tempCanvas = document.createElement("canvas");
                    tempCanvas.setAttribute("width", width);
                    tempCanvas.setAttribute("height", height);
                    var tCtx = tempCanvas.getContext("2d");
                    var shiftX = Math.max(width, height) / 2;
                    var shiftY = Math.max(width, height) / 2;
                    var gradient = tCtx.createRadialGradient(width / 2 + shiftX, height / 2 + shiftY, 1, width / 2 + shiftX, height / 2 + shiftY, Math.max(width / 2, height / 2));
                    gradient.addColorStop(0, color1);
                    gradient.addColorStop(1, color2);
                    var scaleX = height > width ? width / height : 1;
                    var scaleY = width > height ? height / width : 1;
                    tCtx.scale(scaleX, scaleY);
                    tCtx.translate(-shiftX * scaleX, -shiftY * scaleY);
                    tCtx.fillStyle = gradient;
                    tCtx.fillRect(width / 2, height / 2, Math.max(width, height), Math.max(width, height));
                    tCtx.setTransform(1, 0, 0, 1, 0, 0);
                    tCtx.fillStyle = tCtx.createPattern(threeJs.tempCanvasBackgrounds[type]["pattern" + color1 + color2 + dimFloorHundred], "repeat");
                    tCtx.fillRect(0, 0, width, height);
                    var shadowBlur = Math.min(Math.floor(width / 100) * 100, Math.floor(height / 100) * 100) / 10;
                    var inset = shadowBlur / 2;
                    sCtx.shadowBlur = shadowBlur;
                    sCtx.shadowColor = "black";
                    sCtx.fillStyle = "blue";
                    (0, _toConsumableArray2["default"])(Array(9)).forEach(function () {
                      sCtx.fillRect(inset + shadowBlur, inset + shadowBlur, width - (inset + shadowBlur) * 2, height - (inset + shadowBlur) * 2);
                    });
                    sCtx.shadowBlur = 0;
                    sCtx.globalCompositeOperation = "source-in";
                    sCtx.drawImage(tempCanvas, 0, 0);
                    tCtx.clearRect(0, 0, width, height);
                    sCtx.globalCompositeOperation = "source-over";
                  }
                  if (type === "border") {
                    var _props8 = (0, _slicedToArray2["default"])(props, 5),
                      _props8$ = _props8[0],
                      _color6 = _props8$ === void 0 ? "rgba(29,29,38,0.7)" : _props8$,
                      _props8$2 = _props8[1],
                      paddingTopPercent = _props8$2 === void 0 ? 2 : _props8$2,
                      _props8$3 = _props8[2],
                      paddingBottomPercent = _props8$3 === void 0 ? 2 : _props8$3,
                      _props8$4 = _props8[3],
                      paddingLeftPercent = _props8$4 === void 0 ? 2 : _props8$4,
                      _props8$5 = _props8[4],
                      paddingRightPercent = _props8$5 === void 0 ? 2 : _props8$5;
                    var rWidth = width - height * ((paddingLeftPercent + paddingRightPercent) / 100);
                    var rHeight = height - height * ((paddingTopPercent + paddingBottomPercent) / 100);
                    var strokeN = 1000;
                    var strokeWidth = rHeight / strokeN;
                    var startY = height * paddingTopPercent / 100;
                    var startX = height * paddingLeftPercent / 100;
                    var brushSegments = 3;
                    var brushSegmentsHeight = strokeWidth / brushSegments;
                    drawStroke(sCtx, getBrush(Array.isArray(_color6) ? (0, _color15["default"])(_color6[0]) : (0, _color15["default"])(_color6), brushSegments, brushSegmentsHeight), [startX, startY], [startX + rWidth + strokeWidth, startY]);
                    drawStroke(sCtx, getBrush(Array.isArray(_color6) ? (0, _color15["default"])(_color6[1]) : (0, _color15["default"])(_color6), brushSegments, brushSegmentsHeight), [startX + rWidth, startY], [startX + rWidth, startY + rHeight + strokeWidth]);
                    drawStroke(sCtx, getBrush(Array.isArray(_color6) ? (0, _color15["default"])(_color6[2]) : (0, _color15["default"])(_color6), brushSegments, brushSegmentsHeight), [startX + rWidth, startY + rHeight], [startX - strokeWidth, startY + rHeight]);
                    drawStroke(sCtx, getBrush(Array.isArray(_color6) ? (0, _color15["default"])(_color6[3]) : (0, _color15["default"])(_color6), brushSegments, brushSegmentsHeight), [startX, startY + rHeight], [startX, startY - strokeWidth]);
                  }
                  if (type === "titleBox") {
                    var setFontSize = function setFontSize(_ref8) {
                      var width = _ref8.width,
                        height = _ref8.height,
                        text = _ref8.text,
                        _ref8$bold = _ref8.bold,
                        bold = _ref8$bold === void 0 ? "400" : _ref8$bold;
                      var fontSize = 18;
                      sCtx.letterSpacing = fontSize / letterSpacingP + "px";
                      sCtx.font = ["normal", bold, fontSize + 'px Roboto, sans-serif'].join(" ");
                      var titleWidth = sCtx.measureText(text).width;
                      var titleHeight = fontSize;
                      var scaleX = width * 0.8 / titleWidth;
                      var scaleY = height * 0.8 / titleHeight;
                      var scale = Math.min(scaleX, scaleY);
                      if (minFontSize > fontSize * scale) {
                        sCtx.font = ["normal", bold, fontSize * scale + 'px Roboto, sans-serif'].join(" ");
                        minFontSize = fontSize * scale;
                        sCtx.letterSpacing = minFontSize / letterSpacingP + "px";
                      } else {
                        sCtx.font = ["normal", bold, minFontSize + 'px Roboto, sans-serif'].join(" ");
                        sCtx.letterSpacing = minFontSize / letterSpacingP + "px";
                      }
                    };
                    var _props9 = (0, _slicedToArray2["default"])(props, 11),
                      _props9$ = _props9[0],
                      _color7 = _props9$ === void 0 ? "rgba(29,29,38,0.7)" : _props9$,
                      _props9$2 = _props9[1],
                      _paddingTopPercent5 = _props9$2 === void 0 ? 2 : _props9$2,
                      _props9$3 = _props9[2],
                      _paddingBottomPercent5 = _props9$3 === void 0 ? 2 : _props9$3,
                      _props9$4 = _props9[3],
                      _paddingLeftPercent5 = _props9$4 === void 0 ? 2 : _props9$4,
                      _props9$5 = _props9[4],
                      _paddingRightPercent5 = _props9$5 === void 0 ? 2 : _props9$5,
                      _props9$6 = _props9[5],
                      widthPercent = _props9$6 === void 0 ? 30 : _props9$6,
                      _props9$7 = _props9[6],
                      heightPercent = _props9$7 === void 0 ? 10 : _props9$7,
                      _props9$8 = _props9[7],
                      title = _props9$8 === void 0 ? "THE CONSTRUCTIONS" : _props9$8,
                      _props9$9 = _props9[8],
                      subTitle = _props9$9 === void 0 ? "abstract geometric works" : _props9$9,
                      _props9$10 = _props9[9],
                      date = _props9$10 === void 0 ? "2023" : _props9$10,
                      _props9$11 = _props9[10],
                      author = _props9$11 === void 0 ? "" : _props9$11;
                    var _rWidth5 = width - height * ((_paddingLeftPercent5 + _paddingRightPercent5) / 100);
                    var _rHeight5 = height - height * ((_paddingTopPercent5 + _paddingBottomPercent5) / 100);
                    var _strokeN5 = 1000;
                    var _strokeWidth5 = height / _strokeN5;
                    var _brushSegments5 = 3;
                    var _brushSegmentsHeight5 = _strokeWidth5 / _brushSegments5;
                    var endY = height - height * _paddingBottomPercent5 / 100;
                    var endX = width - height * _paddingRightPercent5 / 100;
                    var wP = typeof widthPercent === "number" ? widthPercent : width > height ? widthPercent[0] : widthPercent[1];
                    var w = _rWidth5 / 100 * wP;
                    var h = _rHeight5 / 100 * heightPercent;
                    drawStroke(sCtx, getBrush((0, _color15["default"])(_color7), _brushSegments5, _brushSegmentsHeight5), [endX - w, endY - h], [endX, endY - h]);
                    drawStroke(sCtx, getBrush((0, _color15["default"])(_color7), _brushSegments5, _brushSegmentsHeight5), [endX - w, endY - h], [endX - w, endY]);
                    drawStroke(sCtx, getBrush((0, _color15["default"])(_color7), _brushSegments5, _brushSegmentsHeight5), [endX - w / 3, endY - h], [endX - w / 3, endY]);
                    drawStroke(sCtx, getBrush((0, _color15["default"])(_color7), _brushSegments5, _brushSegmentsHeight5), [endX - w, endY - h / 2], [endX, endY - h / 2]);
                    sCtx.fillStyle = _color7;
                    sCtx.textBaseline = "middle";
                    sCtx.textAlign = "center";
                    var minFontSize = 200;
                    var letterSpacingP = 8;
                    if (Array.isArray(title)) {
                      setFontSize({
                        width: w - w / 3,
                        height: h / 4,
                        text: title[0],
                        bold: "bold"
                      });
                      setFontSize({
                        width: w - w / 3,
                        height: h / 4,
                        text: title[1]
                      });
                    } else {
                      setFontSize({
                        width: w - w / 3,
                        height: h / 2,
                        text: title,
                        bold: "bold"
                      });
                    }
                    if (Array.isArray(subTitle)) {
                      setFontSize({
                        width: w - w / 3,
                        height: h / 4,
                        text: subTitle[0]
                      });
                      setFontSize({
                        width: w - w / 3,
                        height: h / 4,
                        text: subTitle[1]
                      });
                    } else {
                      setFontSize({
                        width: w - w / 3,
                        height: h / 2,
                        text: subTitle
                      });
                    }
                    setFontSize({
                      width: w / 3,
                      height: h / 2,
                      text: date
                    });
                    if (author) {
                      setFontSize({
                        width: w / 3,
                        height: h / 2,
                        text: author
                      });
                    }
                    var _shiftY2 = minFontSize * 0.05;
                    sCtx.font = ["normal", "bold", minFontSize + 'px Roboto, sans-serif'].join(" ");
                    if (Array.isArray(title)) {
                      var titleWidth = sCtx.measureText(title[0]).width;
                      sCtx.fillText(title[0], endX - w + (w - w / 3) / 2, endY - h + h / 2 / 2 + _shiftY2 - minFontSize / 2);
                      sCtx.font = "normal 400 " + minFontSize + 'px Roboto, sans-serif';
                      var title2Width = sCtx.measureText(title[1]).width;
                      var shiftYPlus = minFontSize / 3 * 2;
                      if (title2Width > titleWidth) {
                        var newFontSize = minFontSize * (titleWidth / title2Width) * 0.9;
                        sCtx.font = "normal 400 " + newFontSize + 'px Roboto, sans-serif';
                        shiftYPlus = newFontSize / 3 * 2;
                      }
                      sCtx.fillText(title[1], endX - w + (w - w / 3) / 2, endY - h + h / 2 / 2 + _shiftY2 + shiftYPlus);
                    } else {
                      sCtx.fillText(title, endX - w + (w - w / 3) / 2, endY - h + h / 2 / 2 + _shiftY2);
                    }
                    sCtx.font = "normal 400 " + minFontSize + 'px Roboto, sans-serif';
                    if (Array.isArray(subTitle)) {
                      var subTitleWidth = sCtx.measureText(subTitle[0]).width;
                      sCtx.fillText(subTitle[0], endX - w + (w - w / 3) / 2, endY - h / 2 + h / 2 / 2 + _shiftY2 - minFontSize / 2);
                      sCtx.font = "normal 400 " + minFontSize + 'px Roboto, sans-serif';
                      var subTitle2Width = sCtx.measureText(subTitle[1]).width;
                      var _shiftYPlus2 = minFontSize / 3 * 2;
                      if (subTitle2Width > subTitleWidth) {
                        var _newFontSize2 = minFontSize * (subTitleWidth / subTitle2Width) * 0.9;
                        sCtx.font = "normal 400 " + _newFontSize2 + 'px Roboto, sans-serif';
                        _shiftYPlus2 = _newFontSize2 / 3 * 2;
                      }
                      sCtx.fillText(subTitle[1], endX - w + (w - w / 3) / 2, endY - h / 2 + h / 2 / 2 + _shiftY2 + _shiftYPlus2);
                    } else {
                      sCtx.fillText(subTitle, endX - w + (w - w / 3) / 2, endY - h / 2 + h / 2 / 2 + _shiftY2);
                    }
                    sCtx.fillText(date, endX - w / 3 + w / 3 / 2, endY - h + h / 2 / 2 + _shiftY2);
                    if (author) {
                      sCtx.fillText(author, endX - w / 3 + w / 3 / 2, endY - h / 2 + h / 2 / 2 + _shiftY2);
                    }
                  }
                  if (type === "carco") {
                    var drawCarco = function drawCarco(ctx) {
                      var shiftX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -100;
                      var shiftY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -100;
                      var scale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.238;
                      var lastx = 0;
                      var lasty = 0;
                      var c = {
                        moveTo: function moveTo(x, y) {
                          lastx = x;
                          lasty = y;
                          ctx.moveTo(x * scale, y * scale);
                        },
                        bezierCurveTo: function bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
                          drawStroke(ctx, brush, [lastx * scale, lasty * scale], [x * scale, y * scale], 0, [cp1x * scale, cp1y * scale], [cp2x * scale, cp2y * scale]);
                          lastx = x;
                          lasty = y;
                        }
                      };
                      c.moveTo(241 + shiftX, 153 + shiftY);
                      c.bezierCurveTo(278 + shiftX, 80 + shiftY, 204 + shiftX, 112 + shiftY, 178 + shiftX, 134 + shiftY);
                      c.bezierCurveTo(150 + shiftX, 149 + shiftY, 105 + shiftX, 220 + shiftY, 116 + shiftX, 262 + shiftY);
                      c.bezierCurveTo(123 + shiftX, 287 + shiftY, 169 + shiftX, 300 + shiftY, 196 + shiftX, 269 + shiftY);
                      //c.bezierCurveTo(219 + shiftX, 225 + shiftY, 240 + shiftX, 208 + shiftY, 264 + shiftX, 208 + shiftY);
                      c.moveTo(264 + shiftX, 208 + shiftY);
                      c.bezierCurveTo(215 + shiftX, 202 + shiftY, 199 + shiftX, 225 + shiftY, 183 + shiftX, 264 + shiftY);
                      c.bezierCurveTo(174 + shiftX, 289 + shiftY, 226 + shiftX, 300 + shiftY, 253 + shiftX, 266 + shiftY);
                      c.bezierCurveTo(270 + shiftX, 223 + shiftY, 292 + shiftX, 208 + shiftY, 275 + shiftX, 211 + shiftY);
                      c.bezierCurveTo(266 + shiftX, 200 + shiftY, 230 + shiftX, 273 + shiftY, 244 + shiftX, 283 + shiftY);
                      //c.bezierCurveTo(260 + shiftX, 288 + shiftY, 261 + shiftX, 278 + shiftY, 271 + shiftX, 269 + shiftY);
                      c.moveTo(281 + shiftX, 289 + shiftY);
                      c.bezierCurveTo(281 + shiftX, 289 + shiftY, 311 + shiftX, 220 + shiftY, 311 + shiftX, 220 + shiftY);
                      //c.bezierCurveTo(317 + shiftX, 204 + shiftY, 286 + shiftX, 228 + shiftY, 297 + shiftX, 229 + shiftY);
                      c.moveTo(307 + shiftX, 239 + shiftY);
                      c.bezierCurveTo(293 + shiftX, 244 + shiftY, 330 + shiftX, 202 + shiftY, 360 + shiftX, 224 + shiftY);
                      //c.bezierCurveTo(336 + shiftX, 207 + shiftY, 307 + shiftX, 207 + shiftY, 289 + shiftX, 241 + shiftY);
                      //c.bezierCurveTo(283 + shiftX, 253 + shiftY, 277 + shiftX, 263 + shiftY, 268 + shiftX, 283 + shiftY);
                      //c.bezierCurveTo(304 + shiftX, 227 + shiftY, 321 + shiftX, 267 + shiftY, 343 + shiftX, 249 + shiftY);
                      //c.moveTo(343 + shiftX, 249 + shiftY);
                      //c.bezierCurveTo(351 + shiftX, 232 + shiftY, 380 + shiftX, 201 + shiftY, 421 + shiftX, 213 + shiftY);
                      c.moveTo(401 + shiftX, 203 + shiftY);
                      c.bezierCurveTo(377 + shiftX, 200 + shiftY, 345 + shiftX, 221 + shiftY, 341 + shiftX, 272 + shiftY);
                      c.bezierCurveTo(334 + shiftX, 301 + shiftY, 403 + shiftX, 291 + shiftY, 418 + shiftX, 255 + shiftY);
                      c.bezierCurveTo(433 + shiftX, 233 + shiftY, 451 + shiftX, 212 + shiftY, 471 + shiftX, 213 + shiftY);
                      c.bezierCurveTo(445 + shiftX, 190 + shiftY, 412 + shiftX, 247 + shiftY, 412 + shiftX, 270 + shiftY);
                      c.bezierCurveTo(423 + shiftX, 308 + shiftY, 467 + shiftX, 286 + shiftY, 477 + shiftX, 260 + shiftY);
                      c.bezierCurveTo(492 + shiftX, 239 + shiftY, 496 + shiftX, 217 + shiftY, 480 + shiftX, 211 + shiftY);
                      c.bezierCurveTo(470 + shiftX, 211 + shiftY, 459 + shiftX, 233 + shiftY, 472 + shiftX, 234 + shiftY);
                      c.bezierCurveTo(483 + shiftX, 245 + shiftY, 510 + shiftX, 233 + shiftY, 510 + shiftX, 223 + shiftY);
                    };
                    var _getThreeJsInternalRa3 = getThreeJsInternalRandomFunctions(),
                      _getRandomInt = _getThreeJsInternalRa3.getRandomInt,
                      _setRandomVariables = _getThreeJsInternalRa3.setRandomVariables;
                    _setRandomVariables({
                      threeJs: threeJs
                    });
                    var _props10 = (0, _slicedToArray2["default"])(props, 8),
                      _props10$ = _props10[0],
                      _color8 = _props10$ === void 0 ? "rgba(29,29,38,0.7)" : _props10$,
                      _props10$2 = _props10[1],
                      _paddingTopPercent6 = _props10$2 === void 0 ? 2 : _props10$2,
                      _props10$3 = _props10[2],
                      _paddingBottomPercent6 = _props10$3 === void 0 ? 2 : _props10$3,
                      _props10$4 = _props10[3],
                      _paddingLeftPercent6 = _props10$4 === void 0 ? 2 : _props10$4,
                      _props10$5 = _props10[4],
                      _paddingRightPercent6 = _props10$5 === void 0 ? 2 : _props10$5,
                      _props10$6 = _props10[5],
                      _widthPercent2 = _props10$6 === void 0 ? 10 : _props10$6,
                      _props10$7 = _props10[6],
                      _heightPercent2 = _props10$7 === void 0 ? 5 : _props10$7,
                      _props10$8 = _props10[7],
                      paddingPercent = _props10$8 === void 0 ? 10 : _props10$8;
                    var _rWidth6 = width - height * ((_paddingLeftPercent6 + _paddingRightPercent6) / 100);
                    var _rHeight6 = height - height * ((_paddingTopPercent6 + _paddingBottomPercent6) / 100);
                    var _strokeN6 = Math.floor(_getRandomInt(250, 300));
                    var _strokeWidth6 = height / _strokeN6;
                    var _brushSegments6 = 6;
                    var _brushSegmentsHeight6 = _strokeWidth6 / _brushSegments6;
                    var _endY2 = height - height * _paddingBottomPercent6 / 100;
                    var _endX2 = width - height * _paddingRightPercent6 / 100;
                    var _wP2 = typeof _widthPercent2 === "number" ? _widthPercent2 : width > height ? _widthPercent2[0] : _widthPercent2[1];
                    var _w2 = _rWidth6 / 100 * _wP2;
                    var _h2 = _rHeight6 / 100 * _heightPercent2;

                    //100x46

                    var _scaleX2 = _w2 / 100 * (100 - paddingPercent * 2) / 100;
                    var _scaleY2 = _h2 / 100 * (100 - paddingPercent * 2) / 46;
                    var scale = Math.min(_scaleX2, _scaleY2);
                    var cW = 100 * scale;
                    var cH = 48 * scale;
                    var cD = (0, _color15["default"])(_color8);
                    var brush = getBrush(cD, _brushSegments6, _brushSegmentsHeight6);
                    sCtx.translate(_endX2 - _w2 / 2, _endY2 - _h2 / 2);
                    var randomRotate = _getRandomInt(3, 8);
                    sCtx.rotate(-randomRotate * Math.PI / 180);
                    sCtx.scale(1, _getRandomInt(60, 80) / 100);
                    drawCarco(sCtx, -cW / 2 / (scale * 0.238) - 100, -cH / 2 / (scale * 0.238) - 100, scale * 0.238);
                    sCtx.translate(-_endX2 - _w2 / 2, -_endY2 - _h2 / 2);
                    sCtx.scale(1, 1);
                    sCtx.setTransform(1, 0, 0, 1, 0, 0);
                  }
                  if (type === "sketchBgHorizontal") {
                    var _getThreeJsInternalRa4 = getThreeJsInternalRandomFunctions(),
                      shuffleArray = _getThreeJsInternalRa4.shuffleArray,
                      _setRandomVariables2 = _getThreeJsInternalRa4.setRandomVariables;
                    _setRandomVariables2({
                      threeJs: threeJs
                    });
                    var _props11 = (0, _slicedToArray2["default"])(props, 6),
                      _props11$ = _props11[0],
                      _color9 = _props11$ === void 0 ? "rgba(115,121,128,0.3)" : _props11$,
                      _props11$2 = _props11[1],
                      _paddingTopPercent7 = _props11$2 === void 0 ? 10 : _props11$2,
                      _props11$3 = _props11[2],
                      _paddingBottomPercent7 = _props11$3 === void 0 ? 10 : _props11$3,
                      _props11$4 = _props11[3],
                      _paddingLeftPercent7 = _props11$4 === void 0 ? 10 : _props11$4,
                      _props11$5 = _props11[4],
                      _paddingRightPercent7 = _props11$5 === void 0 ? 10 : _props11$5,
                      _props11$6 = _props11[5],
                      _strokeN7 = _props11$6 === void 0 ? 20 : _props11$6;
                    var _rWidth7 = width - height * ((_paddingLeftPercent7 + _paddingRightPercent7) / 100);
                    var _rHeight7 = height - height * ((_paddingTopPercent7 + _paddingBottomPercent7) / 100);
                    var _strokeWidth7 = _rHeight7 / _strokeN7;
                    var _startY3 = height * _paddingTopPercent7 / 100 + _strokeWidth7;
                    var _startX3 = height * _paddingLeftPercent7 / 100;
                    var _brushSegments7 = 10;
                    var _brushSegmentsHeight7 = _strokeWidth7 / _brushSegments7;
                    var _cD3 = (0, _color15["default"])(_color9);
                    var _brush3 = getBrush(_cD3, _brushSegments7, _brushSegmentsHeight7);
                    var endBrush = getBrush(_cD3, Math.floor(_brushSegments7 / 4 * 3), _brushSegmentsHeight7);
                    var lastPoint = null;
                    var lastStart = null;
                    var shouldStartMiddleSection = null;
                    var randomShiftArray = [0, _strokeWidth7 / 10, _strokeWidth7 / 15, _strokeWidth7 / 5];
                    var randomCurveArray = [0, 4, 8, 10];
                    var overhangUp = shuffleArray([5, 7])[0];
                    var overhangDown = shuffleArray([5, 7])[0];
                    var stepY = _strokeWidth7 * shuffleArray([0.5, 1])[0];
                    var overhangUpHeight = (overhangUp / 2 - 1) * (_strokeWidth7 + stepY) + _strokeWidth7;
                    var overhangDownHeight = (overhangDown / 2 - 1) * (_strokeWidth7 + stepY) + _strokeWidth7;
                    var iL = Math.max(1, Math.floor((_rHeight7 - overhangUpHeight - overhangDownHeight) / _strokeWidth7));
                    _startY3 = _startY3 + overhangUpHeight;
                    var iBA = (0, _toConsumableArray2["default"])(Array(overhangUp));
                    iBA.forEach(function (u, i) {
                      var randomShift = shuffleArray(randomShiftArray)[0] + (i > 0 ? stepY : 0);
                      var randomCurve = shuffleArray(randomCurveArray)[0];
                      var startPoint = lastPoint ? [_startX3, lastPoint[1] - randomShift] : [_startX3, _startY3 - _strokeWidth7 * i - randomShift];
                      var endPoint = [_startX3 + _rWidth7, startPoint[1] - _strokeWidth7];
                      if (i > 0) {
                        startPoint = !(i % 2) ? startPoint : [startPoint[0], lastPoint[1] - randomShift];
                        endPoint = !(i % 2) ? endPoint : [endPoint[0], lastPoint[1]];
                      }
                      var curveHeight = randomCurve ? _strokeWidth7 / randomCurve : 0;
                      if (i === overhangUp - 1) {
                        endPoint = !(i % 2) ? [_startX3 + _rWidth7 / 2, endPoint[1] - _strokeWidth7 / 2] : endPoint;
                        startPoint = !(i % 2) ? startPoint : [_startX3 + _rWidth7 / 2, startPoint[1] - _strokeWidth7 / 2];
                        curveHeight = curveHeight * -4;
                      }
                      lastStart = startPoint;
                      lastPoint = endPoint;
                      if (!shouldStartMiddleSection) {
                        shouldStartMiddleSection = startPoint;
                      }
                      drawStroke(sCtx, i === overhangUp - 1 ? endBrush : _brush3, startPoint, endPoint, curveHeight);
                    });
                    lastPoint = null;
                    var iA = (0, _toConsumableArray2["default"])(Array(iL));
                    iA.forEach(function (u, i) {
                      var randomShift = shuffleArray(randomShiftArray)[0];
                      var randomCurve = shuffleArray(randomCurveArray)[0];
                      var startPoint = shouldStartMiddleSection ? shouldStartMiddleSection : lastPoint ? [_startX3, lastPoint[1] + _strokeWidth7 + randomShift] : [_startX3, _startY3 + _strokeWidth7 * i + randomShift];
                      var endPoint = [_startX3 + _rWidth7, _startY3 + _strokeWidth7 * i + randomShift];
                      var curveHeight = randomCurve ? _strokeWidth7 / randomCurve : 0;
                      drawStroke(sCtx, _brush3, startPoint, endPoint, curveHeight);
                      lastPoint = endPoint;
                      shouldStartMiddleSection = null;
                    });
                    _startY3 = lastPoint[1] + _strokeWidth7;
                    lastPoint = null;
                    lastStart = null;
                    var iAA = (0, _toConsumableArray2["default"])(Array(overhangDown));
                    iAA.forEach(function (u, i) {
                      var randomShift = shuffleArray(randomShiftArray)[0] + (i > 0 ? stepY : 0);
                      var randomCurve = shuffleArray(randomCurveArray)[0];
                      var startPoint = lastStart ? [_startX3, lastStart[1] + _strokeWidth7 + randomShift] : [_startX3, _startY3 + _strokeWidth7 * i + randomShift];
                      var endPoint = [_startX3 + _rWidth7, startPoint[1] - _strokeWidth7];
                      if (i > 0) {
                        startPoint = !(i % 2) ? startPoint : [startPoint[0], lastStart[1]];
                        endPoint = !(i % 2) ? endPoint : [endPoint[0], startPoint[1] + randomShift];
                      }
                      var curveHeight = randomCurve ? _strokeWidth7 / randomCurve : 0;
                      if (i === overhangDown - 1) {
                        startPoint = !(i % 2) ? [_startX3 + _rWidth7 / 2, startPoint[1]] : startPoint;
                        endPoint = !(i % 2) ? endPoint : [_startX3 + _rWidth7 / 2, endPoint[1]];
                        curveHeight = curveHeight * 4;
                      }
                      drawStroke(sCtx, i === overhangDown - 1 ? endBrush : _brush3, startPoint, endPoint, curveHeight);
                      lastStart = startPoint;
                      lastPoint = endPoint;
                    });
                  }
                  if (type === "sketchBgVertical") {
                    var _getThreeJsInternalRa5 = getThreeJsInternalRandomFunctions(),
                      _shuffleArray = _getThreeJsInternalRa5.shuffleArray,
                      _setRandomVariables3 = _getThreeJsInternalRa5.setRandomVariables;
                    _setRandomVariables3({
                      threeJs: threeJs
                    });
                    var _props12 = (0, _slicedToArray2["default"])(props, 6),
                      _props12$ = _props12[0],
                      _color10 = _props12$ === void 0 ? "rgba(115,121,128,0.3)" : _props12$,
                      _props12$2 = _props12[1],
                      _paddingTopPercent8 = _props12$2 === void 0 ? 10 : _props12$2,
                      _props12$3 = _props12[2],
                      _paddingBottomPercent8 = _props12$3 === void 0 ? 10 : _props12$3,
                      _props12$4 = _props12[3],
                      _paddingLeftPercent8 = _props12$4 === void 0 ? 10 : _props12$4,
                      _props12$5 = _props12[4],
                      _paddingRightPercent8 = _props12$5 === void 0 ? 10 : _props12$5,
                      _props12$6 = _props12[5],
                      _strokeN8 = _props12$6 === void 0 ? 20 : _props12$6;
                    var _rWidth8 = width - height * ((_paddingLeftPercent8 + _paddingRightPercent8) / 100);
                    var _rHeight8 = height - height * ((_paddingTopPercent8 + _paddingBottomPercent8) / 100);
                    var _strokeWidth8 = _rHeight8 / _strokeN8;
                    var _startY4 = height * _paddingTopPercent8 / 100;
                    var _startX4 = height * _paddingLeftPercent8 / 100 + _strokeWidth8;
                    var _brushSegments8 = 10;
                    var _brushSegmentsHeight8 = _strokeWidth8 / _brushSegments8;
                    var _cD4 = (0, _color15["default"])(_color10);
                    var _brush4 = getBrush(_cD4, _brushSegments8, _brushSegmentsHeight8);
                    var _endBrush2 = getBrush(_cD4, Math.floor(_brushSegments8 / 4 * 3), _brushSegmentsHeight8);
                    var _lastPoint2 = null;
                    var _lastStart2 = null;
                    var _shouldStartMiddleSection2 = null;
                    var _randomShiftArray2 = [0, _strokeWidth8 / 10, _strokeWidth8 / 15, _strokeWidth8 / 5];
                    var _randomCurveArray2 = [0, 4, 8, 10];
                    var overhangLeft = _shuffleArray([5, 7])[0];
                    var overhangRight = _shuffleArray([5, 7])[0];
                    var _stepY2 = _strokeWidth8 * _shuffleArray([0.5, 1])[0];
                    var overhangLeftWidth = (overhangLeft / 2 - 1) * (_strokeWidth8 + _stepY2) + _strokeWidth8;
                    var overhangRightWidth = (overhangRight / 2 - 1) * (_strokeWidth8 + _stepY2) + _strokeWidth8;
                    var _iL2 = Math.max(1, Math.floor((_rWidth8 - overhangLeftWidth - overhangRightWidth) / _strokeWidth8));
                    _startX4 = _startX4 + overhangLeftWidth;
                    var _iBA2 = (0, _toConsumableArray2["default"])(Array(overhangLeft));
                    _iBA2.forEach(function (u, i) {
                      var randomShift = _shuffleArray(_randomShiftArray2)[0] + (i > 0 ? _stepY2 : 0);
                      var randomCurve = _shuffleArray(_randomCurveArray2)[0];
                      var startPoint = _lastPoint2 ? [_lastPoint2[0] - randomShift, _startY4] : [_startX4 - _strokeWidth8 * i - randomShift, _startY4];
                      var endPoint = [startPoint[0] - _strokeWidth8, _startY4 + _rHeight8];
                      if (i > 0) {
                        startPoint = !(i % 2) ? startPoint : [_lastPoint2[0] - randomShift, startPoint[1]];
                        endPoint = !(i % 2) ? endPoint : [_lastPoint2[0], endPoint[1]];
                      }
                      var curveHeight = randomCurve ? _strokeWidth8 / randomCurve : 0;
                      if (i === overhangLeft - 1) {
                        endPoint = !(i % 2) ? [endPoint[0] - _strokeWidth8 / 2, _startY4 + _rHeight8 / 2] : endPoint;
                        startPoint = !(i % 2) ? startPoint : [startPoint[0] - _strokeWidth8 / 2, _startY4 + _rHeight8 / 2];
                        curveHeight = curveHeight * -4;
                      }
                      _lastStart2 = startPoint;
                      _lastPoint2 = endPoint;
                      if (!_shouldStartMiddleSection2) {
                        _shouldStartMiddleSection2 = startPoint;
                      }
                      drawStroke(sCtx, i === overhangLeft - 1 ? _endBrush2 : _brush4, startPoint, endPoint, curveHeight);
                    });
                    _lastPoint2 = null;
                    var _iA2 = (0, _toConsumableArray2["default"])(Array(_iL2));
                    _iA2.forEach(function (u, i) {
                      var randomShift = _shuffleArray(_randomShiftArray2)[0];
                      var randomCurve = _shuffleArray(_randomCurveArray2)[0];
                      var startPoint = _shouldStartMiddleSection2 ? _shouldStartMiddleSection2 : _lastPoint2 ? [_lastPoint2[0] + _strokeWidth8 + randomShift, _startY4] : [_startX4 + _strokeWidth8 * i + randomShift, _startY4];
                      var endPoint = [_startX4 + _strokeWidth8 * i + randomShift, _startY4 + _rHeight8];
                      var curveHeight = randomCurve ? _strokeWidth8 / randomCurve : 0;
                      drawStroke(sCtx, _brush4, startPoint, endPoint, curveHeight);
                      _lastPoint2 = endPoint;
                      _shouldStartMiddleSection2 = null;
                    });
                    _startX4 = _lastPoint2[0] + _strokeWidth8;
                    _lastPoint2 = null;
                    _lastStart2 = null;
                    var _iAA2 = (0, _toConsumableArray2["default"])(Array(overhangRight));
                    _iAA2.forEach(function (u, i) {
                      var randomShift = _shuffleArray(_randomShiftArray2)[0] + (i > 0 ? _stepY2 : 0);
                      var randomCurve = _shuffleArray(_randomCurveArray2)[0];
                      var startPoint = _lastStart2 ? [_lastStart2[0] + _strokeWidth8 + randomShift, _startY4] : [_startX4 + _strokeWidth8 * i + randomShift, _startY4];
                      var endPoint = [startPoint[0] - _strokeWidth8, _startY4 + _rHeight8];
                      if (i > 0) {
                        startPoint = !(i % 2) ? startPoint : [_lastStart2[0], startPoint[1]];
                        endPoint = !(i % 2) ? endPoint : [startPoint[0] + randomShift, endPoint[1]];
                      }
                      var curveHeight = randomCurve ? _strokeWidth8 / randomCurve : 0;
                      if (i === overhangRight - 1) {
                        startPoint = !(i % 2) ? [startPoint[0], _startY4 + _rHeight8 / 2] : startPoint;
                        endPoint = !(i % 2) ? endPoint : [endPoint[0], _startY4 + _rHeight8 / 2];
                        curveHeight = curveHeight * 4;
                      }
                      drawStroke(sCtx, i === overhangRight - 1 ? _endBrush2 : _brush4, startPoint, endPoint, curveHeight);
                      _lastStart2 = startPoint;
                      _lastPoint2 = endPoint;
                    });
                  }
                  if (type === "path") {
                    var _props13 = (0, _slicedToArray2["default"])(props, 7),
                      _props13$ = _props13[0],
                      _color11 = _props13$ === void 0 ? "#eeac56" : _props13$,
                      _props13$2 = _props13[1],
                      _paddingTopPercent9 = _props13$2 === void 0 ? 0 : _props13$2,
                      _props13$3 = _props13[2],
                      _paddingBottomPercent9 = _props13$3 === void 0 ? 0 : _props13$3,
                      _props13$4 = _props13[3],
                      _paddingLeftPercent9 = _props13$4 === void 0 ? 0 : _props13$4,
                      _props13$5 = _props13[4],
                      _paddingRightPercent9 = _props13$5 === void 0 ? 0 : _props13$5,
                      _props13$6 = _props13[5],
                      data = _props13$6 === void 0 ? [] : _props13$6,
                      _props13$7 = _props13[6],
                      lockRefSize = _props13$7 === void 0 ? 0 : _props13$7;
                    var lw = lockRefSize === 1 ? width : lockRefSize === 2 ? height : width;
                    var lh = lockRefSize === 1 ? width : lockRefSize === 2 ? height : height;
                    var _rWidth9 = width - lw * ((_paddingLeftPercent9 + _paddingRightPercent9) / 100);
                    var _rHeight9 = height - lh * ((_paddingTopPercent9 + _paddingBottomPercent9) / 100);
                    var _startX5 = lw * _paddingLeftPercent9 / 100;
                    var _startY5 = lh * _paddingTopPercent9 / 100;
                    if (data.length) {
                      data.forEach(function (d, i) {
                        var x = _startX5 + _rWidth9 / 100 * d[0];
                        var y = _startY5 + _rHeight9 / 100 * d[1];
                        if (i === 0) {
                          sCtx.beginPath();
                          sCtx.moveTo(x, y);
                        } else {
                          sCtx.lineTo(x, y);
                        }
                      });
                      sCtx.fillStyle = _color11;
                      sCtx.fill();
                      sCtx.closePath();
                    }
                  }
                  if (type === "pathSquareCenter") {
                    var _props14 = (0, _slicedToArray2["default"])(props, 6),
                      _props14$ = _props14[0],
                      _color12 = _props14$ === void 0 ? "#eeac56" : _props14$,
                      _props14$2 = _props14[1],
                      _paddingTopPercent10 = _props14$2 === void 0 ? 0 : _props14$2,
                      _props14$3 = _props14[2],
                      _paddingBottomPercent10 = _props14$3 === void 0 ? 0 : _props14$3,
                      _props14$4 = _props14[3],
                      _paddingLeftPercent10 = _props14$4 === void 0 ? 0 : _props14$4,
                      _props14$5 = _props14[4],
                      _paddingRightPercent10 = _props14$5 === void 0 ? 0 : _props14$5,
                      _props14$6 = _props14[5],
                      _data = _props14$6 === void 0 ? [] : _props14$6;
                    var _lockRefSize = width > height ? 2 : 1;
                    var _lw = _lockRefSize === 1 ? width : _lockRefSize === 2 ? height : width;
                    var _lh = _lockRefSize === 1 ? width : _lockRefSize === 2 ? height : height;
                    var _rWidth10 = _lw - _lw * ((_paddingLeftPercent10 + _paddingRightPercent10) / 100);
                    var _rHeight10 = _lh - _lh * ((_paddingTopPercent10 + _paddingBottomPercent10) / 100);
                    var _startX6 = (width - _lw) / 2 + _lw * _paddingLeftPercent10 / 100;
                    var _startY6 = (height - _lh) / 2 + _lh * _paddingTopPercent10 / 100;
                    if (_data.length) {
                      _data.forEach(function (d, i) {
                        var x = _startX6 + _rWidth10 / 100 * d[0];
                        var y = _startY6 + _rHeight10 / 100 * d[1];
                        if (i === 0) {
                          sCtx.beginPath();
                          sCtx.moveTo(x, y);
                        } else {
                          sCtx.lineTo(x, y);
                        }
                      });
                      sCtx.fillStyle = _color12;
                      sCtx.fill();
                      sCtx.closePath();
                    }
                  }
                  if (type === "rectangle") {
                    var _props15 = (0, _slicedToArray2["default"])(props, 6),
                      _props15$ = _props15[0],
                      _color13 = _props15$ === void 0 ? "#eeac56" : _props15$,
                      _props15$2 = _props15[1],
                      _paddingTopPercent11 = _props15$2 === void 0 ? 0 : _props15$2,
                      _props15$3 = _props15[2],
                      _paddingBottomPercent11 = _props15$3 === void 0 ? 0 : _props15$3,
                      _props15$4 = _props15[3],
                      _paddingLeftPercent11 = _props15$4 === void 0 ? 0 : _props15$4,
                      _props15$5 = _props15[4],
                      _paddingRightPercent11 = _props15$5 === void 0 ? 0 : _props15$5,
                      _props15$6 = _props15[5],
                      _lockRefSize2 = _props15$6 === void 0 ? 0 : _props15$6;
                    var _lw2 = _lockRefSize2 === 1 ? width : _lockRefSize2 === 2 ? height : width;
                    var _lh2 = _lockRefSize2 === 1 ? width : _lockRefSize2 === 2 ? height : height;
                    var _rWidth11 = width - _lw2 * ((_paddingLeftPercent11 + _paddingRightPercent11) / 100);
                    var _rHeight11 = height - _lh2 * ((_paddingTopPercent11 + _paddingBottomPercent11) / 100);
                    var _startX7 = _lw2 * _paddingLeftPercent11 / 100;
                    var _startY7 = _lh2 * _paddingTopPercent11 / 100;
                    sCtx.beginPath();
                    sCtx.rect(_startX7, _startY7, _rWidth11, _rHeight11);
                    sCtx.fillStyle = _color13;
                    sCtx.fill();
                    sCtx.closePath();
                  }
                  if (type === "rectangleSquareCenter") {
                    var _props16 = (0, _slicedToArray2["default"])(props, 5),
                      _props16$ = _props16[0],
                      _color14 = _props16$ === void 0 ? "#eeac56" : _props16$,
                      _props16$2 = _props16[1],
                      _paddingTopPercent12 = _props16$2 === void 0 ? 0 : _props16$2,
                      _props16$3 = _props16[2],
                      _paddingBottomPercent12 = _props16$3 === void 0 ? 0 : _props16$3,
                      _props16$4 = _props16[3],
                      _paddingLeftPercent12 = _props16$4 === void 0 ? 0 : _props16$4,
                      _props16$5 = _props16[4],
                      _paddingRightPercent12 = _props16$5 === void 0 ? 0 : _props16$5;
                    var _lockRefSize3 = width > height ? 2 : 1;
                    var _lw3 = _lockRefSize3 === 1 ? width : _lockRefSize3 === 2 ? height : width;
                    var _lh3 = _lockRefSize3 === 1 ? width : _lockRefSize3 === 2 ? height : height;
                    var _rWidth12 = _lw3 - _lw3 * ((_paddingLeftPercent12 + _paddingRightPercent12) / 100);
                    var _rHeight12 = _lh3 - _lh3 * ((_paddingTopPercent12 + _paddingBottomPercent12) / 100);
                    var _startX8 = (width - _lw3) / 2 + _lw3 * _paddingLeftPercent12 / 100;
                    var _startY8 = (height - _lh3) / 2 + _lh3 * _paddingTopPercent12 / 100;
                    sCtx.beginPath();
                    sCtx.rect(_startX8, _startY8, _rWidth12, _rHeight12);
                    sCtx.fillStyle = _color14;
                    sCtx.fill();
                    sCtx.closePath();
                  }
                  threeJs.tempCanvasBackgrounds[type][saveName] = saveCanvas;
                }
                ctx.drawImage(threeJs.tempCanvasBackgrounds[type][saveName], 0, 0);
              });
            }
          });
        }
      };
      var draw = threeJs.version && versions[threeJs.version] ? versions[threeJs.version] : versions["1"];
      draw();
    }
  }
  function addComposer() {
    var _threeJs$composer, _threeJs$composer$ren, _threeJs$composer2, _threeJs$composer2$wa, _threeJs$composer4, _threeJs$composer4$re;
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs;
    var _p$camera = p.camera,
      camera = _p$camera === void 0 ? threeJs.camera : _p$camera,
      _p$renderer = p.renderer,
      renderer = _p$renderer === void 0 ? threeJs.renderer : _p$renderer,
      _p$scene = p.scene,
      scene = _p$scene === void 0 ? threeJs.scene : _p$scene,
      n = p.n;
    var postprocessing = threeJs.packages.postprocessing;
    var EffectComposer = postprocessing.EffectComposer,
      RenderPass = postprocessing.RenderPass,
      Effect = postprocessing.Effect,
      EffectPass = postprocessing.EffectPass;
    renderer.composer = new EffectComposer(renderer);
    var renderPass = new RenderPass(scene, camera);
    renderer.composer.addPass(renderPass);
    var rendererOpacity = typeof ((_threeJs$composer = threeJs.composer) === null || _threeJs$composer === void 0 ? void 0 : (_threeJs$composer$ren = _threeJs$composer.renderer) === null || _threeJs$composer$ren === void 0 ? void 0 : _threeJs$composer$ren.opacity) === "number" ? threeJs.composer.renderer.opacity : 0.5;
    if ((_threeJs$composer2 = threeJs.composer) !== null && _threeJs$composer2 !== void 0 && (_threeJs$composer2$wa = _threeJs$composer2.waterColor) !== null && _threeJs$composer2$wa !== void 0 && _threeJs$composer2$wa.enable) {
      var _threeJs$composer3, _threeJs$composer3$wa;
      var WaterColorEffect = /*#__PURE__*/function (_Effect) {
        (0, _inherits2["default"])(WaterColorEffect, _Effect);
        var _super = (0, _createSuper2["default"])(WaterColorEffect);
        function WaterColorEffect(props) {
          (0, _classCallCheck2["default"])(this, WaterColorEffect);
          var blendFunction = props.blendFunction; // || BlendFunction.LINEAR_DODGE;
          var _waterColorEffect = (0, _waterColorEffect2["default"])((0, _objectSpread2["default"])({
              THREE: THREE
            }, props)),
            fragmentShader = _waterColorEffect.fragmentShader,
            rest = (0, _objectWithoutProperties2["default"])(_waterColorEffect, _excluded);
          return _super.call(this, "WaterColorEffect", fragmentShader, (0, _objectSpread2["default"])({
            blendFunction: blendFunction
          }, rest));
        }
        (0, _createClass2["default"])(WaterColorEffect, [{
          key: "intensity",
          get: function get() {
            return this.uniforms.get("intensity").value;
          },
          set: function set(value) {
            this.uniforms.get("intensity").value = value;
          }
        }, {
          key: "getIntensity",
          value: function getIntensity() {
            return this.intensity;
          }
        }, {
          key: "setIntensity",
          value: function setIntensity(value) {
            this.intensity = value;
          }
        }]);
        return WaterColorEffect;
      }(Effect);
      var effect = new EffectPass(camera, new WaterColorEffect({
        intensity: typeof ((_threeJs$composer3 = threeJs.composer) === null || _threeJs$composer3 === void 0 ? void 0 : (_threeJs$composer3$wa = _threeJs$composer3.waterColor) === null || _threeJs$composer3$wa === void 0 ? void 0 : _threeJs$composer3$wa.intensity) === "number" ? threeJs.composer.waterColor.intensity : 1 - rendererOpacity
      }));
      renderer.composer.addPass(effect);
    }
    renderer.domElement.style.opacity = rendererOpacity;
    renderer.domElement.style.mixBlendMode = typeof ((_threeJs$composer4 = threeJs.composer) === null || _threeJs$composer4 === void 0 ? void 0 : (_threeJs$composer4$re = _threeJs$composer4.renderer) === null || _threeJs$composer4$re === void 0 ? void 0 : _threeJs$composer4$re.blendMode) === "string" ? threeJs.composer.renderer.blendMode : "";
    renderer.renderComposer = function () {
      var _renderer$composer;
      var nD = !n ? 1 : n;
      var tempEnabledEditLines = camera.layers.isEnabled(nD * 6 + 1);
      camera.layers.disable(nD * 6 + 1);
      var tempEnabledCalloutNotations = camera.layers.isEnabled(nD * 6 + 2);
      camera.layers.disable(nD * 6 + 2);
      (_renderer$composer = renderer.composer).render.apply(_renderer$composer, arguments);
      var context = renderer.effectElement.getContext("2d");
      context.clearRect(0, 0, renderer.effectElement.width, renderer.effectElement.height);
      context.drawImage(renderer.domElement, 0, 0);
      if (tempEnabledEditLines) {
        camera.layers.enable(nD * 6 + 1);
      }
      if (tempEnabledCalloutNotations) {
        camera.layers.enable(nD * 6 + 2);
      }
      renderer.render(threeJs.scene, camera);
    };
  }
  function applyPostFilters() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs;
    var _threeJs$postFilters = threeJs.postFilters,
      postFilters = _threeJs$postFilters === void 0 ? [] : _threeJs$postFilters;
    var filterString = postFilters && postFilters.map(function (postFilter) {
      return postFilter.type + "(" + postFilter.value + ")";
    }).join(" ") || "";
    var na = [0, 2, 3, 4];
    na.forEach(function (n) {
      var _threeJs$splitScreenD11, _threeJs$splitScreenD12, _threeJs$splitScreenD13, _threeJs$splitScreenD14;
      var rendererPropName = n ? "renderer" + n : "renderer";
      var splitScreenCustomPostFilters = (threeJs.splitScreen || n > 0) && (_threeJs$splitScreenD11 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD11 !== void 0 && _threeJs$splitScreenD11.renderersData && (_threeJs$splitScreenD12 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD12 !== void 0 && _threeJs$splitScreenD12.renderersData["" + n] && (_threeJs$splitScreenD13 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD13 !== void 0 && _threeJs$splitScreenD13.renderersData["" + n].postFilters ? (_threeJs$splitScreenD14 = threeJs.splitScreenData) === null || _threeJs$splitScreenD14 === void 0 ? void 0 : _threeJs$splitScreenD14.renderersData["" + n].postFilters : null;
      var splitScreenCustomPostFilterString = splitScreenCustomPostFilters && splitScreenCustomPostFilters.map(function (postFilter) {
        return postFilter.type + "(" + postFilter.value + ")";
      }).join(" ") || "";
      var fS = !threeJs.splitScreen && n === 0 ? filterString : splitScreenCustomPostFilterString;
      if (threeJs[rendererPropName] && threeJs[rendererPropName].effectElement) {
        threeJs[rendererPropName].effectElement.style.filter = fS;
      }
      if (threeJs[rendererPropName] && threeJs[rendererPropName].domElement) {
        threeJs[rendererPropName].domElement.style.filter = fS;
      }
    });
  }
  function getCameraProps(n, threeJs) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _data$splitScreen = data.splitScreen,
      splitScreen = _data$splitScreen === void 0 ? threeJs.splitScreen : _data$splitScreen,
      _data$splitScreenData = data.splitScreenData,
      splitScreenData = _data$splitScreenData === void 0 ? threeJs.splitScreenData : _data$splitScreenData,
      _data$cameraPosition = data.cameraPosition,
      cameraPosition = _data$cameraPosition === void 0 ? threeJs.cameraPosition : _data$cameraPosition,
      _data$defaultTarget = data.defaultTarget,
      defaultTarget = _data$defaultTarget === void 0 ? threeJs.defaultTarget : _data$defaultTarget,
      _data$cameraZoom = data.cameraZoom,
      cameraZoom = _data$cameraZoom === void 0 ? threeJs.cameraZoom : _data$cameraZoom;
    var position = (splitScreen || n > 0) && splitScreenData !== null && splitScreenData !== void 0 && splitScreenData.renderersData && splitScreenData !== null && splitScreenData !== void 0 && splitScreenData.renderersData[n] && splitScreenData !== null && splitScreenData !== void 0 && splitScreenData.renderersData[n].cameraPosition ? new THREE.Vector3(splitScreenData.renderersData[n].cameraPosition.x, splitScreenData.renderersData[n].cameraPosition.y, splitScreenData.renderersData[n].cameraPosition.z) : cameraPosition;
    var target = (splitScreen || n > 0) && splitScreenData !== null && splitScreenData !== void 0 && splitScreenData.renderersData && splitScreenData !== null && splitScreenData !== void 0 && splitScreenData.renderersData[n] && splitScreenData !== null && splitScreenData !== void 0 && splitScreenData.renderersData[n].cameraTarget ? new THREE.Vector3(splitScreenData.renderersData[n].cameraTarget.x, splitScreenData.renderersData[n].cameraTarget.y, splitScreenData.renderersData[n].cameraTarget.z) : defaultTarget;
    var zoom = (splitScreen || n > 0) && splitScreenData !== null && splitScreenData !== void 0 && splitScreenData.renderersData && splitScreenData !== null && splitScreenData !== void 0 && splitScreenData.renderersData[n] && splitScreenData !== null && splitScreenData !== void 0 && splitScreenData.renderersData[n].cameraZoom ? splitScreenData.renderersData[n].cameraZoom : cameraZoom;
    var set = function set() {
      if (threeJs.camera) {
        threeJs.camera.position.set(position.x, position.y, position.z);
      }
      if (threeJs.target) {
        threeJs.target.x = target.x;
        threeJs.target.y = target.y;
        threeJs.target.z = target.z;
      }
      if (threeJs.camera) {
        threeJs.camera.lookAt(target.x, target.y, target.z);
        threeJs.camera.zoom = zoom;
      }
    };
    return {
      position: position,
      target: target,
      zoom: zoom,
      set: set
    };
  }
  function addCameraAndRenderer() {
    var _threeJs$composer5;
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs,
      domElement = p.domElement,
      _p$rendererPropName = p.rendererPropName,
      rendererPropName = _p$rendererPropName === void 0 ? "renderer" : _p$rendererPropName,
      _p$cameraPropName = p.cameraPropName,
      cameraPropName = _p$cameraPropName === void 0 ? "camera" : _p$cameraPropName,
      _p$left = p.left,
      left = _p$left === void 0 ? 0 : _p$left,
      _p$top = p.top,
      top = _p$top === void 0 ? 0 : _p$top,
      _p$visibility = p.visibility,
      visibility = _p$visibility === void 0 ? "visible" : _p$visibility,
      style = p.style;
    var n = cameraPropName === "camera" ? 0 : Number(cameraPropName.slice(-1));
    var SVGRenderer = threeJs.packages.SVGRenderer;
    var parentContainer = threeJs.parentContainer;
    var width = parentContainer.offsetWidth;
    var height = parentContainer.offsetHeight;
    if (width / height < 1) {
      height = width;
    }
    if (typeof p.width !== "undefined" && p.height !== "undefined") {
      width = p.width;
      height = p.height;
    }
    var aspect = width / height;
    threeJs[cameraPropName] = threeJs.cameraType === "perspective" ? new THREE.PerspectiveCamera(threeJs.cameraFov, aspect, 1, 2000) : new THREE.OrthographicCamera(-threeJs.cameraD * aspect, threeJs.cameraD * aspect, threeJs.cameraD, -threeJs.cameraD, -10000, 10000);
    var nD = !n ? 1 : n;
    threeJs[cameraPropName].layers.disableAll();
    threeJs[cameraPropName].layers.enable(nD * 6);
    threeJs[cameraPropName].layers.enable(nD * 6 + 1);
    threeJs[cameraPropName].layers.enable(nD * 6 + 2);
    threeJs[cameraPropName].layers.enable(nD * 6 + 3);
    if (threeJs.renderType === "SVG") {
      threeJs[rendererPropName] = new SVGRenderer();
    } else {
      threeJs[rendererPropName] = new THREE.WebGLRenderer({
        antialias: true,
        canvas: rendererPropName === "renderer" ? domElement : undefined,
        alpha: true,
        powerPreference: "high-performance"
      });
    }
    threeJs[rendererPropName].domElement.style.width = width + "px";
    threeJs[rendererPropName].domElement.style.height = height + "px";
    threeJs[rendererPropName].domElement.style.left = left + "%";
    threeJs[rendererPropName].domElement.style.top = top + "%";
    threeJs[rendererPropName].domElement.style.visibility = visibility;
    threeJs[rendererPropName].setSize(width, height);
    if (threeJs[rendererPropName].domElement && (0, _toConsumableArray2["default"])(domElement.parentElement.children).indexOf(threeJs[rendererPropName].domElement) === -1) {
      if (threeJs.removeBackground) {
        threeJs[rendererPropName].domElement.classList.add(style.transparentBg);
      }
      domElement.parentElement.append(threeJs[rendererPropName].domElement);
    }
    if (!threeJs[rendererPropName].effectElement) {
      threeJs[rendererPropName].effectElement = document.createElement("canvas");
      threeJs[rendererPropName].effectElement.classList.add(style[rendererPropName]);
    }
    threeJs[rendererPropName].effectElement.setAttribute("width", width);
    threeJs[rendererPropName].effectElement.setAttribute("height", height);
    threeJs[rendererPropName].effectElement.style.width = width + "px";
    threeJs[rendererPropName].effectElement.style.height = height + "px";
    threeJs[rendererPropName].effectElement.style.left = left + "%";
    threeJs[rendererPropName].effectElement.style.top = top + "%";
    threeJs[rendererPropName].effectElement.style.visibility = visibility;
    if (threeJs[rendererPropName].effectElement && (0, _toConsumableArray2["default"])(threeJs.effectsContainer.children).indexOf(threeJs[rendererPropName].effectElement) === -1) {
      threeJs.effectsContainer.append(threeJs[rendererPropName].effectElement);
    }
    var classEnd = threeJs.renderType || "SVG";
    threeJs[rendererPropName].domElement.classList.add(style["renderer" + classEnd]);
    threeJs[rendererPropName].domElement.classList.add(style[rendererPropName]);
    if (threeJs[rendererPropName].shadowMap) {
      var _threeJs$shadow;
      if ((_threeJs$shadow = threeJs.shadow) !== null && _threeJs$shadow !== void 0 && _threeJs$shadow.enable) {
        threeJs[rendererPropName].shadowMap.enabled = true;
        threeJs[rendererPropName].shadowMap.type = THREE.PCFShadowMap;
        //threeJs[rendererPropName].shadowMap.type = THREE.VSMShadowMap;
        threeJs[rendererPropName].shadowMap.autoUpdate = false;
        threeJs[rendererPropName].shadowMap.needsUpdate = true;
      }
    } else if (threeJs.renderType === "SVG") {
      //threeJs[rendererPropName].setQuality( "low" );
      threeJs[rendererPropName].overdraw = 0.3;
    }
    if (threeJs.renderType !== "SVG" && (_threeJs$composer5 = threeJs.composer) !== null && _threeJs$composer5 !== void 0 && _threeJs$composer5.enable) {
      addComposer({
        threeJs: threeJs,
        renderer: threeJs[rendererPropName],
        camera: threeJs[cameraPropName],
        n: cameraPropName === "camera" ? 0 : Number(cameraPropName.slice(-1))
      });
      if (threeJs[rendererPropName].composer) {
        threeJs[rendererPropName].composer.setSize(width, height);
      }
    }
  }
  return {
    setBackground: setBackground,
    setCanvasBackground: setCanvasBackground,
    getCameraProps: getCameraProps,
    addCameraAndRenderer: addCameraAndRenderer,
    applyPostFilters: applyPostFilters
  };
}